<template>
  <div id="detail" class="hotel_container">
    <div class="hotel_container_panel">
      <el-breadcrumb
        separator-class="el-icon-arrow-right"
        style="height: 5rem; line-height: 5rem"
      >
        <el-breadcrumb-item>{{ $t("DETAIL.HOME") }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t("DETAIL.HOTELRESULT") }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t("DETAIL.DETAILPAGE") }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t("BOOKING.BOOKING") }}</el-breadcrumb-item>
      </el-breadcrumb>
      <!-- begin content -->
      <!-- begin message promept -->
      <div class="message-prompt">
        {{ $t("BOOKING.MESSAGEPROMEPT") }}
      </div>
      <!-- end message promept -->
      <div class="confirmation_panel">
        <Loading :loading="submitLoading" />
        <div class="info_detal_l">
          <BookingHeader></BookingHeader>
          <el-form
            ref="bookingForm"
            :model="bookingForm"
            label-width="8rem"
            label-position="top"
          >
            <!-- begin Check-in information  -->
            <div class="special_checkin panel_bg base">
              <div style="pointer-events: none" v-if="$objBaseInfo.channelId == 'WEB'">
                <date-room
                  :roomNum="pageParam.roomCount"
                  :guestNum="pageParam.guestCount"
                  :setDataValue="checkInOutDate"
                ></date-room>
              </div>
              <!-- begin Booking Information  -->

              <div class="checkin_prompt">
                <span>{{ $t("BOOKING.CHECKININFO") }}</span>
              </div>
              <!-- begin room information -->
              <div class="room-info">
                <div class="title">{{ $t("BOOKING.TITLE") }}</div>
                <el-row :gutter="10">
                  <!-- 姓名 -->
                  <el-col :lg="8">
                    <el-form-item
                      :label="$t('BOOKING.COLNAME')"
                      prop="name"
                      class="form-label-field"
                      :rules="[{required: true,message: this.$t('BOOKING.VALIDATEMES1'),trigger: ['change'],},]"
                    >
                      <el-input
                        @click="showNamePop('bookingForm')"
                        auto-complete="off"
                        type="text"
                        readonly
                        :disabled="nameFocus"
                        v-model="bookingForm.name"
                      ></el-input>
                      <!-- </div> -->
                    </el-form-item>
                  </el-col>
                  <!-- 手机号 -->
                  <el-col :xs="12" :lg="8">
                    <el-form-item
                      :label="$t('BOOKING.COLTELEPHONE')"
                      prop="mobile"
                      class="form-label-field"
                      :rules="mobileRules"
                    >
                      <el-input
                        :required="true"
                        v-model="bookingForm.mobile"
                        @focus="handleFocus(1)"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <!-- 邮箱 -->
                  <el-col :xs="12" :lg="8">
                    <el-form-item
                      :label="$t('BOOKING.EMAIL')"
                      prop="email"
                      class="form-label-field"
                      :rules="[
                        {
                          required: true,
                          message: this.$t('BOOKING.VALIDATEMES3'),
                          trigger: ['blur', 'change'],
                        },
                        {
                          type: 'email',
                          message: this.$t('USERDIALOG.GUESTEMAIL2'),
                          trigger: ['blur', 'change'],
                        },
                      ]"
                    >
                      <el-input v-model="bookingForm.email"></el-input>
                    </el-form-item>
                  </el-col>
                  <!-- 证件号码 -->
                  <el-col :xs="24" :lg="12" v-if="bookingForm.showIdNumber">
                    <el-form-item
                      :label="$t('cardTypeDialog.idNumber')"
                      prop="cardTypeNumber"
                      class="form-label-field"
                      :rules="[{required: true,message: this.$t('cardTypeRules.IdCardEmpty'),trigger: ['change']}]"
                    >
                      <div style="display: flex; width: 100%; gap: 10px; align-items: center;">
                        <el-select v-model="bookingForm.cardType" :disabled="bookingForm.cardTypeSelectDisabled">
                          <el-option v-for="item in cardTypeOption" 
                            :key="item.value" 
                            :label="item.label" 
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                        <el-input readonly v-model="bookingForm.cardTypeNumber" :disabled="false" auto-complete="off" type="text"></el-input>
                        <el-button @click="openCardTypeDialog" :disabled="bookingForm.cardTypeButtonDisabled" :class="{ 'editCardTypeButtonStyle': !bookingForm.cardTypeButtonDisabled }">{{ $t("INVOICINGBUTTON.DEIT") }}</el-button>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="10">
                  <!-- 会员卡 -->
                  <el-col :xs="24" :lg="24" v-if="loyaltyCardInfo.showLoyatyCard && isIntegralGroup">
                    <el-form-item :label="$t('BOOKING.MEMBERSHIPCARD')" class="form-label-field" prop="loyaltyCardType"
                    :rules="[ {pattern:/^[a-zA-Z0-9]{1,21}$/,message: this.$t('BOOKING.MEMBERSHIPCARDTRIPSRule'),trigger: ['blur', 'change'],},]"
                    >
                      <el-select :clearable="true" v-model="bookingForm.loyaltyCardType" @change="loyaltyCardOptionChange" :placeholder="$t('MANUAL.SELECTPLACEHOLDER')">
                        <el-option v-for="item in loyaltyCardInfo.loyaltyCardOptions" :key="item.key" :label="item.label" :value="item.value">
                          <span style="float: left">{{ item.label }}</span>
                          <span style="float: right;margin-right: 1rem;">{{ $i18n.locale === "en" ? item.groupEnName : item.groupName }}</span>
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <div style="margin-top:1.5rem;"> <span class="special_alert">{{$t("BOOKING.MEMBERSHIPCARDMSG")}}</span></div>
                  </el-col>
                  <el-col :xs="24" :lg="12" v-if="loyaltyCardInfo.showInputLoyatyCard && isIntegralGroup">
                    <el-form-item :label="$t('BOOKING.MEMBERSHIPCARD')" class="form-label-field" prop="loyaltyCardTypeInput"
                      :rules="[ {pattern:/^[a-zA-Z0-9]{1,21}$/,message: this.$t('BOOKING.MEMBERSHIPCARDTRIPSRule'),trigger: ['blur', 'change'],},]"
                    >
                      <el-input v-model="bookingForm.loyaltyCardTypeInput" @input="clearCNCarNum(2)"></el-input>
                    </el-form-item>
                    <div style="margin-top:1.5rem;"> <span class="special_alert">{{$t("BOOKING.MEMBERSHIPCARDMSG")}}</span></div>
                   
                  </el-col>
                  <el-col :xs="24" :lg="2" class="loyaltyCard-btn" v-if="loyaltyCardInfo.showLoyatyCard && isIntegralGroup && isAdd">
                    <el-button @click="showAddLoyatyCard">{{ $t("BOOKING.ADDMEMBERSHIPCARD") }}</el-button>
                  </el-col>
                  <el-col :xs="24" :lg="2" class="loyaltyCard-btn" v-if="loyaltyCardInfo.showLoyatyCard && isIntegralGroup && !isAdd">
                    <el-button @click="showAddLoyatyCard">{{ $t("BOOKING.EDITMEMBERSHIPCARD") }}</el-button>
                  </el-col>
                </el-row>
                <el-row :gutter="10" v-if="showLinker">
                  <!-- 联系人姓名 -->
                  <el-col :lg="8">
                    <el-form-item
                      :label="$t('MANUAL.CONTACTNAME')"
                      prop="linkerName"
                      class="form-label-field"
                      :rules="[
                      { required: true, message: $t('BOOKING.VALIDATEMES1'), trigger: ['blur', 'change'] },
                      ]"
                    >
                      <el-input :required="true" v-model="bookingForm.linkerName"></el-input>
                    </el-form-item>
                  </el-col>
                    <!-- 联系人手机号 -->
                    <el-col :xs="12" :lg="8">
                    <el-form-item
                      :label="$t('MANUAL.CONTACTMOBILE')"
                      prop="linkerMobile"
                      class="form-label-field"
                      :rules="linkerMobileRules"
                    >
                      <el-input :required="true" v-model="bookingForm.linkerMobile" @focus="handleFocus(3)"></el-input>
                    </el-form-item>
                  </el-col>
                  <!-- 联系人邮箱 -->
                  <el-col :xs="12" :lg="8">
                    <el-form-item
                      :label="$t('MANUAL.CONTACTEMAIL')"
                      prop="linkerEmail"
                      class="form-label-field"
                      :rules="[
                        {
                          required: true,
                          message: this.$t('BOOKING.VALIDATEMES3'),
                          trigger: ['blur', 'change'],
                        },
                        {
                          type: 'email',
                          message: this.$t('USERDIALOG.GUESTEMAIL2'),
                          trigger: ['blur', 'change'],
                        },
                      ]"
                    >
                      <el-input :required="true" v-model="bookingForm.linkerEmail"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <div class="title" v-if="isMultiplayerBooking" style="margin-top:1.5rem;">{{ $t("BOOKING.OTHERTITLE") }}</div>
                <el-row :gutter="10" v-if="isMultiplayerBooking">
                  <!-- 姓名 -->
                  <el-col :lg="8">
                    <el-form-item
                      :label="$t('BOOKING.COLNAME')"
                      prop="bookingFormOther.name"
                      class="form-label-field"
                      :rules="[
                        {
                          required: true,
                          message: this.$t('BOOKING.VALIDATEMES1'),
                          trigger: ['change'],
                        },
                      ]"
                    >
                      <el-input
                        @click="showNamePop('bookingFormOther')"
                        auto-complete="off"
                        type="text"
                        readonly
                        v-model="bookingForm.bookingFormOther.name"
                      ></el-input>
                      <!-- </div> -->
                    </el-form-item>
                  </el-col>
                  <!-- 手机号 -->
                  <el-col :xs="12" :lg="8">
                    <el-form-item
                      :label="$t('BOOKING.COLTELEPHONE')"
                      prop="bookingFormOther.mobile"
                      class="form-label-field"
                      :rules="otherMobileRules"
                    >
                      <el-input
                        :required="true"
                        v-model="bookingForm.bookingFormOther.mobile"
                        @focus="handleFocus(2)"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <!-- 邮箱 -->
                  <el-col :xs="12" :lg="8">
                    <el-form-item
                      :label="$t('BOOKING.EMAIL')"
                      prop="bookingFormOther.email"
                      class="form-label-field"
                      :rules="[
                        {
                          required: true,
                          message: this.$t('BOOKING.VALIDATEMES3'),
                          trigger: ['blur', 'change'],
                        },
                        {
                          type: 'email',
                          message: this.$t('USERDIALOG.GUESTEMAIL2'),
                          trigger: ['blur', 'change'],
                        },
                      ]"
                    >
                      <el-input 
                      v-model="bookingForm.bookingFormOther.email"></el-input>
                    </el-form-item>
                    <span class="colorRed">{{ $t("BOOKING.OTHERTITLEPROMPT") }}</span>
                  </el-col>
                    <!-- 第二入住人证件号码 -->
                  <el-col :xs="24" :lg="12" v-if="bookingForm.bookingFormOther.showIdNumber">
                    <el-form-item
                      :label="$t('cardTypeDialog.idNumber')"
                      prop="bookingFormOther.cardTypeNumber"
                      class="form-label-field"
                      :rules="[{required: true,message: this.$t('cardTypeRules.IdCardEmpty'),trigger: ['change']}]"
                    >
                      <div style="display: flex; width: 100%; gap: 10px; align-items: center;">
                        <el-select v-model="bookingForm.bookingFormOther.cardType" :disabled="bookingForm.bookingFormOther.cardTypeSelectDisabled">
                          <el-option v-for="item in cardTypeOption" 
                            :key="item.value" 
                            :label="item.label" 
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                        <el-input readonly v-model="bookingForm.bookingFormOther.cardTypeNumber" :disabled="false" auto-complete="off" type="text"></el-input>
                        <el-button @click="openOtherCardTypeDialog" :disabled="bookingForm.bookingFormOther.cardTypeButtonDisabled" :class="{ 'editCardTypeButtonStyle': !bookingForm.bookingFormOther.cardTypeButtonDisabled }">{{ $t("INVOICINGBUTTON.DEIT") }}</el-button>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10" v-if="showLinker && isMultiplayerBooking">
                  <!-- 联系人姓名 -->
                  <el-col :lg="8">
                    <el-form-item
                      :label="$t('MANUAL.CONTACTNAME')"
                      prop="bookingFormOther.linkerName"
                      class="form-label-field"
                      :rules="[
                      { required: true, message: $t('BOOKING.VALIDATEMES1'), trigger: ['blur', 'change'] },
                      ]"
                    >
                      <el-input :required="true" v-model="bookingForm.bookingFormOther.linkerName"></el-input>
                    </el-form-item>
                  </el-col>
                    <!-- 联系人手机号 -->
                    <el-col :xs="12" :lg="8">
                    <el-form-item
                      :label="$t('MANUAL.CONTACTMOBILE')"
                      prop="bookingFormOther.linkerMobile"
                      class="form-label-field"
                      :rules="otherLinkerMobileRules"
                    >
                      <el-input :required="true" v-model="bookingForm.bookingFormOther.linkerMobile" @focus="handleFocus(4)"></el-input>
                    </el-form-item>
                  </el-col>
                  <!-- 联系人邮箱 -->
                  <el-col :xs="12" :lg="8">
                    <el-form-item
                      :label="$t('MANUAL.CONTACTEMAIL')"
                      prop="bookingFormOther.linkerEmail"
                      class="form-label-field"
                      :rules="[
                        {
                          required: true,
                          message: this.$t('BOOKING.VALIDATEMES3'),
                          trigger: ['blur', 'change'],
                        },
                        {
                          type: 'email',
                          message: this.$t('USERDIALOG.GUESTEMAIL2'),
                          trigger: ['blur', 'change'],
                        },
                      ]"
                    >
                      <el-input :required="true" v-model="bookingForm.bookingFormOther.linkerEmail"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <div class="panel_dividing_line"></div>
                <el-row :gutter="10">
                  <!-- 支付方式 -->
                  <el-col :xs="24" :lg="12">
                    <el-form-item
                      :label="$t('BOOKING.PAYMENTTYPE')"
                      prop="paymentType"
                      class="form-label-field"
                    >
                      <el-select
                        v-model="bookingForm.paymentType"
                        :placeholder="$t('BOOKING.CHOOSENTYPE')"
                      >
                        <el-option
                          v-for="item in opt3"
                          :key="'pay' + item"
                          :label="
                            $t('COMMONPARAM.PAYMENTTYPE.PAYMENTTYPE' + item)
                          "
                          :value="item"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <!-- 最晚到店时间 -->
                  <el-col :xs="24" :lg="12">
                    <el-form-item
                      :label="$t('BOOKING.LATESTARRIVALT')"
                      prop="latestArrivalTime"
                      class="form-label-field"
                    >
                      <el-select v-model="bookingForm.latestArrivalTime" @change="LatestArrivalTimeChange" :disabled = "latestArrivalTimeDisabled">
                        <el-option
                          v-for="item in opt4"
                          :key="item"
                          :label="item"
                          :value="item"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <div class="special_alert">{{ specialalert(bookingForm.paymentType) }}</div>
                </el-row>
                <!-- <div class="panel_dividing_line"></div> -->
                <!-- 特殊需求 -->
                <el-row :gutter="10" v-if="($objBaseInfo || {}).sourceType == 'CRM' && (bookingCreateParam.source == 'sabre'|| bookingCreateParam.source == 'sabre-oversea')">
                  <!-- 特殊需求房型 -->
                  <el-col :xs="24" :lg="12">
                    <el-form-item
                      :label="$t('BOOKING.SPECIALROOM')"
                      prop="specialRoom"
                      class="form-label-field"
                    >
                      <el-select v-model="bookingForm.specialRoom">
                        <el-option
                          v-for="item in specialRoomArr"
                          :key="'sroom' + item.value"
                          :label="
                            item.name[$t('COMMONPARAM.RESPONSEDATA.SHOWTYPE')]
                          "
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <!-- 特殊需求床型 -->
                  <el-col :xs="24" :lg="12">
                    <el-form-item
                      :label="$t('BOOKING.SPECIALBED')"
                      prop="specialBed"
                      class="form-label-field"
                    >
                      <el-select v-model="bookingForm.specialBed">
                        <el-option
                          v-for="item in specialBedArr"
                          :key="'sbed' + item.value"
                          :label="
                            item.name[$t('COMMONPARAM.RESPONSEDATA.SHOWTYPE')]
                          "
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <div class="panel_dividing_line" v-show="isCostCenterShow"></div>
                <!-- 成本中心 -->
                <el-row :gutter="10" v-show="isCostCenterShow">
                  <!-- 成本中心 -->
                  <el-col :xs="24" :lg="24">
                    <el-form-item
                      :label="$t('BOOKING.CostCenter')"
                      class="form-label-field"
                    >
                      <el-select 
                      v-model="bookingForm.costCenterid" 
                      @change="CostCenterChange($event)"
                      v-el-select-loadmore="CostCenterloadMore(costCenterrangeNumber)"
                      filterable :filter-method="filterMethod" 
                      @visible-change="visibleChange"
                      :disabled="isCostCenterEdit">
                        <el-option :key="0" :label="$t('MANUAL.SELECTPLACEHOLDER')" :value="0"></el-option>
                        <el-option
                          v-for="item in costCenteroptions.slice(0, costCenterrangeNumber)"
                          :key="item.id"
                          :label="item.costName"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <!-- end room information -->
              <!-- end Booking Information  -->
            </div>
            <!-- end Check-in information  -->
            <!-- begin Management Information  -->
            <!-- MI信息 -->
            <div class="special_checkin panel_bg base">
              <div class="special_prompt">
                <span>{{ $t("BOOKING.SPECIAL") }}</span>
              </div>

              <div
                class="form"
                v-loading="miLoading"
                element-loading-background="rgba(240,248,255, 0.8)"
              >
                <el-row :gutter="10" style="margin: 0 -5px 1rem">
                  <template v-for="(item, index) in miList">
                    <!-- 文本输入框 -->
                    <el-col 
                      v-if="item.textTypeCode === 'text'"
                      :key="'text' + index"
                    >
                      <el-form-item
                        :label="$i18n.locale == 'zh' ? item.miNameCN : item.miNameEN"
                        :rules="[{
                            required: item.needResult == 1,
                            message: $i18n.locale == 'zh' ? '请输入' + item.miNameCN : 'Please input ' + item.miNameEN,
                            trigger: 'blur'
                          }, {
                            pattern: new RegExp(eval2(item.textValue.regularStr)),
                            message: $i18n.locale == 'zh' ? '请输入正确的' + item.miNameCN : 'Please input the correct ' + item.miNameEN,
                          }
                        ]"
                        :prop="item.relationMIKey"
                        class="form-label-field"
                      >
                        <el-input
                          v-model="bookingForm[item.relationMIKey]"
                          @input="miDropChange($event, item)"
                          :maxlength="item.textValue.textLength == 0 ? 100 : item.textValue.textLength"
                        ></el-input>
                        
                        <!-- 提示链接 - MOBILE -->
                        <div style="line-height:20px !important;" v-if="$objBaseInfo.channelId == 'MOBILE'">
                          <a 
                            style="word-break:break-word;" 
                            class="miNoteFont" 
                            :class="[getMINoteShow(item) ? 'miNoteFontT' : 'miNoteFontF']" 
                            href="javascript:void(0)" 
                            @click="getMINoteShow(item) && MobileMINoteLink(item)"
                          >{{ getMINote(item) }}</a>
                        </div>
                        
                        <!-- 提示链接 - WEB -->
                        <div style="line-height:20px !important;" v-if="$objBaseInfo.channelId == 'WEB'">
                          <a 
                            style="word-break:break-word;" 
                            class="miNoteFont" 
                            :class="[getMINoteShow(item) ? 'miNoteFontT' : 'miNoteFontF']" 
                            :href="getMINoteLink(item)" 
                            :target="[getMINoteShow(item) ? '_blank' : '']"
                          >{{ getMINote(item) }}</a>
                        </div>
                      </el-form-item>
                    </el-col>

                    <!-- 下拉选择框 -->
                    <el-col 
                      v-if="item.textTypeCode === 'down'"
                      :key="'down' + index"
                      :xs="24" 
                      :lg="24"
                    >
                      <el-form-item
                        :label="$i18n.locale == 'zh' ? item.miNameCN : item.miNameEN"
                        :rules="[{
                            required: item.needResult == 1,
                            message: $i18n.locale == 'zh' ? '请输入' + item.miNameCN : 'Please input ' + item.miNameEN,
                            trigger: 'change'
                          }
                        ]"
                        :prop="item.relationMIKey"
                        class="form-label-field"
                      >
                        <el-select
                          v-model="bookingForm[item.relationMIKey]"
                          @change="miDropChange($event, item)"
                          v-el-select-loadmore="loadMore(rangeNumber)"
                        >
                          <el-option
                            v-for="itemL in item.dropDowns.slice(0, rangeNumber)"
                            :key="itemL.nameCN"
                            :label="$i18n.locale == 'zh' ? itemL.nameCN : itemL.nameEN"
                            :value="itemL.downCode"
                          />
                        </el-select>
                        
                        <!-- 提示链接 - MOBILE -->
                        <div style="line-height:20px !important;" v-if="$objBaseInfo.channelId == 'MOBILE'">
                          <a 
                            style="word-break:break-word;" 
                            class="miNoteFont" 
                            :class="[getMINoteShow(item) ? 'miNoteFontT' : 'miNoteFontF']" 
                            href="javascript:void(0)" 
                            @click="getMINoteShow(item) && MobileMINoteLink(item)"
                          >{{ getMINote(item) }}</a>
                        </div>
                        
                        <!-- 提示链接 - WEB -->
                        <div style="line-height:20px !important;" v-if="$objBaseInfo.channelId == 'WEB'">
                          <a 
                            style="word-break:break-word;" 
                            class="miNoteFont" 
                            :class="[getMINoteShow(item) ? 'miNoteFontT' : 'miNoteFontF']" 
                            :href="getMINoteLink(item)" 
                            :target="[getMINoteShow(item) ? '_blank' : '']"
                          >{{ getMINote(item) }}</a>
                        </div>
                      </el-form-item>
                    </el-col>
                  </template>
                </el-row>
              </div>
            </div>
              <!-- RC超标 -->
            <div v-if="isShowPOSRC" class="special_checkin panel_bg base">
              <div class="special_prompt">
                <span>{{ $t('BOOKING.ReasonCode') }}</span>
              </div>
              <div
                class="form"
                v-loading="miLoading"
                element-loading-background="rgba(240,248,255, 0.8)"
              >
                <el-row style="margin: 0 -5px 1rem">
                  <el-col :span="12">
                    <el-form-item
                      :label="$t('BOOKING.ReasonCode')"
                      prop="POSRCTextValue"
                      class="form-label-field"
                      :rules="[
                        {
                          required: true,
                          message: $t('MESSAGE.PLEASESELECT'),
                          trigger: ['blur', 'change'],
                        },
                      ]"
                    >
                      <el-select v-model="bookingForm.POSRCTextValue" style="width: 100%">
                        <el-option
                          v-for="item in getPOSRCTextList"
                          :key="item.code"
                          :label="item.value"
                          :value="item.code"
                        />
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </div>`
            <!-- end Management Information  -->
          </el-form>
        </div>
        <BookingRight></BookingRight>
      </div>
      <!--begin content -->
    </div>
    <!-- start name dialog -->
    <el-dialog
      width="90rem"
      class="dialog-one"
      v-model="dialogUserName"
      :show-close="false"
      :before-close="nameDialogClose"
    >
      <Loading :loading="clientLoading" />
      <el-tabs v-model="activeName" @tab-click="choseeTab">
        <el-row class="user-search-row" :gutter="16">
          <el-col :span="isGuestBtn ? 6 : 8" class="search-input">
            <div>{{ $t("USERDIALOG.SEARCHNAME") }}</div>
            <el-input v-model="searchName"></el-input>
          </el-col>
          <el-col :span="isGuestBtn ? 6 : 8" class="search-input">
            <div>{{ $t("USERDIALOG.SEARCHTEL") }}</div>
            <el-input v-model="searchTel"></el-input>
          </el-col>
          <el-col :span="isGuestBtn ? 4 : 8" class="search-btn">
            <el-button @click="pageChange(1)">{{ $t("USERDIALOG.BTNSEARCH") }}</el-button>
          </el-col>
          <el-col v-show="isGuestBtn" :span="4" class="search-btn">
            <el-button @click="dialogUserName = false; dialogAddGuest = true">{{  $t("USERDIALOG.BTNGUEST") }}</el-button>
          </el-col>
        </el-row>
        <el-tab-pane
          v-if="isClientTab"
          :label="$t('USERDIALOG.TABNAEM1')"
          name="first"
        >
          <el-table :data="clientData" :cell-style="{ padding: '15px 0' }">
            <el-table-column
              prop="travelerName"
              :label="$t('USERDIALOG.TABLENAME')"
              width="150"
            ></el-table-column>
            <el-table-column
              prop="staffNum"
              :label="$t('USERDIALOG.TABLEEMPLOYEEID')"
              width="150"
            ></el-table-column>
            <el-table-column
              prop="departmentName"
              :label="$t('USERDIALOG.DEPARTMENT')"
            ></el-table-column>
            <el-table-column prop="email" :label="$t('USERDIALOG.SEARCHEMAIL')" width="200"></el-table-column>
            <el-table-column prop="mobile" :label="$t('USERDIALOG.TABLETEL')">
              <template #default="{ row }">
                <span>{{ formatMobile(row.mobile) }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('USERDIALOG.OPERATION')">
              <template #default="scope">
                <div class="select-btn" @click="selectTraveler(scope.row)">
                  {{ $t("USERDIALOG.SELECT") }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane v-if="isTempGuest" :label="$t('USERDIALOG.TABNAEM2')" name="second">
          <el-table :data="guestData" :cell-style="{ padding: '15px 0' }">
            <el-table-column
              prop="psgName"
              :label="$t('USERDIALOG.TABLENAME')"
              width="200"
            ></el-table-column>
            <el-table-column
              prop="mobile"
              :label="$t('USERDIALOG.TABLETEL')"
              width="200"
            ></el-table-column>
            <el-table-column
              prop="cardNo"
              :label="$t('USERDIALOG.IDNUMBER')"
            ></el-table-column>
            <el-table-column :label="$t('USERDIALOG.OPERATION')">
              <template #default="scope">
                <div class="select-btn" @click="selectTraveler(scope.row)">
                  {{ $t("USERDIALOG.SELECT") }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-row style="float: right; margin: 2%">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="pagination.total"
            :page-size="pagination.pageSize"
            :current-page="pagination.currentPage"
            @current-change="pageChange"
          >
          </el-pagination>
        </el-row>
      </el-tabs>
    </el-dialog>
    <van-popup
      v-model:show="mobileNameShow"
      position="bottom"
      :style="{ height: '65%' }"
    >
      <form>
        <van-search
          v-model="searchName"
          class="mobileSearchStyle"
          show-action
          :label="$t('USERDIALOG.SEARCHNAME')"
          @search="pageChange(1)"
        >
          <template #action>
            <div @click="pageChange(1)">{{ $t("USERDIALOG.BTNSEARCH") }}</div>
          </template>
        </van-search>
      </form>
      <van-tabs v-model:active="activeName" @click-tab="choseeMobileTab" animated sticky>
        <van-tab v-if="isClientTab" :title="$t('USERDIALOG.TABNAEM1')" name="first">
          <van-radio-group v-model="clientRadio">
            <van-cell-group>
              <van-cell
                v-for="item in clientData"
                :key="item.travelerCode"
                clickable
                @click="choseeClient(item)"
                class="traval-pop-chose"
              >
                <div class="traval-pop-cell-content">
                  <span class="traval-pop-cell-title">{{ item.travelerName + '-' + item.staffNum }}</span>
                  <van-radio :name="item.travelerCode" icon-size="2rem" />
                </div>
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </van-tab>
        <van-tab v-if="isTempGuest" :title="$t('USERDIALOG.TABNAEM2')" name="second">
          <van-button
            round
            type="info"
            size="large"
            class="addGuestMobile"
            @click="
              mobileNameShow = false;
              mobileAddGuestShow = true;
            "
            >{{ $t("USERDIALOG.BTNGUEST") }}</van-button
          >
          <van-radio-group v-model="guestRadio">
            <van-cell-group>
              <van-cell
                v-for="item in guestData"
                :key="item.pkId"
                clickable
                @click="choseeGuest(item)"
                class="traval-pop-chose"
              >
                <div class="traval-pop-cell-content">
                  <span class="traval-pop-cell-title">{{ item.psgName + '-' + item.mobile }}</span>
                  <van-radio :name="item.pkId" icon-size="2rem" />
                </div>
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </van-tab>
      </van-tabs>
      <van-pagination
        v-model="vantcurrPage"
        :total-items="mobileTotalNum"
        :items-per-page="5"
        mode="simple"
        @change="pageChange"
      />
    </van-popup>
    <van-popup
      v-model:show="mobileAddGuestShow"
      position="bottom"
      :style="{ height: '40%' }"
    >
      <p class="traval-pop-title">{{ $t('USERDIALOG.BTNGUEST') }}</p>
      <van-form ref="mobileAddGuestForm" validate-first @submit="addGuest" style="margin-top: 1rem;">
        <van-field
          class="guestAddField"
          v-model="addGuestInfo.guestName"
          :label="$t('USERDIALOG.NAME')"
          :placeholder="$t('BOOKING.INPUTCARDHOLDER')"
          required
          autocomplete="off"
          name="guestName"
          :rules="[
            { required: true, message: $t('USERDIALOG.GUESTNAME') },
            { validator: mobileGuestPass, message: $t('BOOKING.GUESTNAMERULE') },
          ]"
        />
        <van-field
          class="guestAddField"
          v-model="addGuestInfo.guestMobile"
          maxlength="11"
          type="number"
          required
          :label="$t('USERDIALOG.TEL')"
          autocomplete="off"
          name="guestMobile"
          :rules="[
            { required: true, message: $t('USERDIALOG.GUESTMOBILE') },
            {
              pattern: /^1[3456789]\d{9}$/,
              message: this.$t('BOOKING.PHONEVA'),
            },
          ]"
        />
        <van-field
          class="guestAddField"
          required
          v-model="addGuestInfo.guestEmail"
          :label="$t('USERDIALOG.EMAIL')"
          autocomplete="off"
          name="guestEmail"
          :rules="[
            { required: true, message: $t('USERDIALOG.GUESTEMAIL') },
            {
              pattern: /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/,
              message: this.$t('USERDIALOG.GUESTEMAIL2'),
            },
          ]"
        />
        <div style="margin: 16px;">
          <van-button round block type="info" native-type="submit">{{
            $t("MESSAGE.CONFIRMBUTTONTEXT")
          }}</van-button>
        </div>
      </van-form>
    </van-popup>
    <!-- traveler -->
    <el-dialog
      width="90rem"
      class="dialog-traveler"
      :title="$t('USERDIALOG.TRAVELERTITLE')"
      v-model="dialogTraveler"
      :show-close="false"
    >
      <Loading :loading="travelerLoading" />
      <el-table :data="travelerData">
        <el-table-column
          prop="userName"
          :label="$t('USERDIALOG.TABLENAME')"
          width="150"
        ></el-table-column>
        <el-table-column
          prop="mobile"
          :label="$t('USERDIALOG.TABLETEL')"
          width="150"
        ></el-table-column>
        <el-table-column
          prop="employeeID"
          :label="$t('USERDIALOG.TABLEEMPLOYEEID')"
        ></el-table-column>
        <el-table-column
          prop="email"
          :label="$t('USERDIALOG.SEARCHEMAIL')"
        ></el-table-column>
        <el-table-column width="150" :label="$t('USERDIALOG.OPERATION')">
          <template #default="scope">
            <div class="select-btn" @click="selectTravelerName(scope.row)">
              {{ $t("USERDIALOG.SELECT") }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- vant 出行人 -->
    <van-popup
      v-model:show="mobileTravelShow"
      position="bottom"
      :style="{ height: '50%' }"
    >
      <p class="traval-pop-title">{{ $t("USERDIALOG.TRAVELERTITLE") }}</p>
      <van-radio-group v-model="travelRadio">
        <van-cell-group>
          <van-cell
            v-for="item in travelerData"
            :key="item.employeeID"
            :title="item.userName + '-' + item.employeeID"
            clickable
            @click="choseeTravel(item)"
            class="traval-pop-chose"
          >
            <template #right-icon>
              <van-radio :name="item.employeeID" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </van-popup>
    <!-- end name dialog -->
    <!-- start add guest dialog -->
    <el-dialog
      width="40rem"
      class="dialog-two"
      :title="$t('USERDIALOG.BTNGUEST')"
      v-model="dialogAddGuest"
      :show-close="false"
      append-to-body
    >
      <el-divider class="title-divider"></el-divider>
      <el-form
        :model="addGuestInfo"
        label-position="right"
        style="text-align: center"
        ref="addGuestInfo"
        :inline="true"
      >
        <el-row class="dialog-form-row">
          <el-col :span="24">
            <el-form-item
              :label="$t('USERDIALOG.NAME')"
              prop="guestName"
              :rules="[
                {
                  required: true,
                  message: this.$t('USERDIALOG.GUESTNAME'),
                  trigger: 'blur',
                },
                {
                  validator: guestNameRule,
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                v-model="addGuestInfo.guestName"
                :placeholder="$t('BOOKING.INPUTCARDHOLDER')"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="dialog-form-row">
          <el-col :span="24">
            <el-form-item
              :label="$t('USERDIALOG.TEL')"
              prop="guestMobile"
              :rules="[
                {
                  required: true,
                  message: this.$t('USERDIALOG.GUESTMOBILE'),
                  trigger: 'blur',
                },
                {
                  pattern: /^1[3456789]\d{9}$/,
                  message: this.$t('BOOKING.PHONEVA'),
                  trigger: ['blur', 'change'],
                },
              ]"
            >
              <el-input
                v-model="addGuestInfo.guestMobile"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="dialog-form-row">
          <el-col :span="24">
            <el-form-item
              :label="$t('USERDIALOG.EMAIL')"
              prop="guestEmail"
              :rules="[
                {
                  required: true,
                  message: this.$t('USERDIALOG.GUESTEMAIL'),
                  trigger: 'blur',
                },
                {
                  type: 'email',
                  message: this.$t('USERDIALOG.GUESTEMAIL2'),
                  trigger: ['blur', 'change'],
                },
              ]"
            >
              <el-input
                v-model="addGuestInfo.guestEmail"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
      <div class="dialog-footer">
        <el-button type="primary" class="search-btn" @click="addGuest">{{
          $t("MESSAGE.CONFIRMBUTTONTEXT")
        }}</el-button>
        <el-button @click="dialogAddGuest = false">{{
          $t("MESSAGE.CONFIRMCANCELTEXT")
        }}</el-button>
      </div>
      </template>
    </el-dialog>
    <!-- end add guest dialog -->
    <!-- 子组件确认框  confirmMsg 提示内容-->
    <ConfirmBoxs
      :centerDialogVisible="confirmFlag"
      :confirmMsg="confirmMsg"
      :icon="confirmIcon"
      @setConfirmFlag="setConfirmFlag"
    ></ConfirmBoxs>
    <!-- begin price dialog -->
    <el-dialog
      v-model="showPriceFlag"
      :title="$t('PRICEDIALOG.TITLE')"
      :destroy-on-close="true"
      class="price-dialog"
    >
      <el-divider class="title-divider"></el-divider>
      <el-table :data="transData" :show-header="false">
        <el-table-column align="center" class-name="el-header-price" fixed>
          <template #default="scope">
            {{ scope.row[0] }}
          </template>
        </el-table-column>
        <el-table-column
          v-for="item in columnLength"
          :key="item"
          align="center"
          width="130rem"
        >
          <template #default="scope">
            {{ scope.row[item] }}
          </template>
        </el-table-column>
      </el-table>
      <!-- <el-row class="taxState">{{ $t("PRICEDIALOG.TAXSTATE") }}</el-row> -->
    </el-dialog>
    <el-dialog
      v-model="showMobilePriceFlag"
      :title="$t('PRICEDIALOG.TITLE')"
      width="90%"
      class="price-dialog"
    >
      <el-divider class="title-divider"></el-divider>
      <el-table :data="originData" max-height="300" style="width: 100%">
        <el-table-column
          prop="date"
          align="center"
          :label="$t('PRICEDIALOG.DATE')"
          width="">
        </el-table-column>
        <el-table-column
          prop="price"
          align="center"
          :label="$t('PRICEDIALOG.PRICE')"
        >
        </el-table-column>
        <!-- <el-table-column
          prop="tax"
          align="center"
          :label="$t('PRICEDIALOG.TAX')"
          v-if="($objBaseInfo.destinationType =='I' || $objBaseInfo.isGATCity) && isShowTax"
        >
        </el-table-column>
        <el-table-column
          prop="fee"
          align="center"
          :label="$t('PRICEDIALOG.FEE')"
          v-if="($objBaseInfo.destinationType =='I' || $objBaseInfo.isGATCity) && isShowOther"
        >
        </el-table-column> -->
      </el-table>
    </el-dialog>
    <!-- end price dialog -->
    <!-- 价格变化弹框 -->
    <el-dialog
      v-model="dialogProceed"
      width="40rem"
      center
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      class="d_confirm"
    >
      <span class="dialog-span-fixed">
        <svg-icon icon-class="exclamation"></svg-icon>
        <span class="dialog-span-content">
          <div>
            {{ $t("DETAIL.PRICECHANGED") }}
            <br />
            {{ $t("DETAIL.ORGPRICE") }} {{ this.originAmount }}
            {{ $t("DETAIL.NEWPRICE") }} {{ this.newAmount }}
          </div>
        </span>
      </span>
      <template #footer>
      <span class="dialog-footer">
        <button style="padding: 0;" class="dialog_btn_y btn_dialog four_btn" @click="continueBook">
          {{ $t("CONFIRMATION.PROCEED") }}
        </button>
        <button style="padding: 0;" class="dialog_btn_n btn_dialog four_btn" @click="cancleBook">
          {{ $t("CONFIRMATION.CANCLEBTN") }}
        </button>
      </span>
      </template>
    </el-dialog>

    <el-dialog
      v-model="dialogOut"
      width="40rem"
      center
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      class="d_confirm"
    >
      <span class="dialog-span-fixed">
        <svg-icon icon-class="exclamation"></svg-icon>
        <span class="dialog-span-content" v-html="outMsg"></span>
      </span>
      <template #footer>
      <span class="dialog-footer">
        <button style="padding: 0;" class="dialog_btn_y btn_dialog four_btn" @click="continueBook">
          {{ $t("CONFIRMATION.PROCEED") }}
        </button>
        <button style="padding: 0;" class="dialog_btn_n btn_dialog four_btn" @click="cancleBook">
          {{ $t("CONFIRMATION.CANCLEBTN") }}
        </button>
      </span>
      </template>
    </el-dialog>

    <!-- 判断是否有重复订单弹框 -->
    <el-dialog
      v-model="verifyRepeatOrderFlag"
      width="40rem"
      center
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      class="d_confirm"
    >
      <span class="dialog-span-fixed">
        <svg-icon icon-class="exclamation"></svg-icon>
        <span class="dialog-span-content">
          <div>
             {{ $t("BOOKING.VERIFYREPEATORDERTITLE") }}
          </div>
        </span>
      </span>
      <template #footer>
      <span class="dialog-footer">
        <button style="padding: 0;" class="dialog_btn_y btn_dialog four_btn" @click="continueRepeatOrderConfirm">
          {{ $t("CONFIRMATION.PROCEED") }}
        </button>
        <button style="padding: 0;" class="dialog_btn_n btn_dialog four_btn" @click="CancelRepeatOrderConfirm">
          {{ $t("CONFIRMATION.CANCLEBTN") }}
        </button>
      </span>
      </template>
    </el-dialog>

    <!-- 添加会员卡 -->
    <el-dialog 
      v-model="loyaltyCardInfo.dialogAddLoyaltyCard" 
      :title="isAdd ? $t('BOOKING.ADDMEMBERSHIPCARD') : $t('BOOKING.EDITMEMBERSHIPCARD')"  
      width="40rem" 
      class="dialog-two" 
      append-to-body
    >
      <el-divider class="title-divider"></el-divider>
      <el-form 
        :model="loyaltyCardInfo.addLoyaltyCardInfo" 
        label-position="right" 
        style="text-align: center" 
        ref="addGuestInfo" 
        :inline="true"
      >
        <el-row class="dialog-form-row">
          <el-col class="col_loyaltyCard">
            <el-form-item :label="$t('BOOKING.HOTELGROUP')">
              <el-select 
                v-model="loyaltyCardInfo.hotelgroupName" 
                @change="loyaltyCardChange"
                style="width: 100%"
              >
                <el-option 
                  v-for="item in loyaltyCardInfo.hotelgroupsInfo" 
                  :key="item.key" 
                  :label="item.value" 
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col class="col_loyaltyCard">
            <el-form-item 
              :label="$t('BOOKING.MEMBERSHIPCARD')" 
              prop="cardNum"
              :rules="[ 
                { required: true, message: $t('BOOKING.MEMBERSHIPCARDTRIPS'), trigger: ['blur', 'change'] },
                { pattern: /^[a-zA-Z0-9]{1,21}$/, message: $t('BOOKING.MEMBERSHIPCARDTRIPSRule'), trigger: ['blur', 'change'] }
              ]"
            >
              <el-input 
                v-model="loyaltyCardInfo.addLoyaltyCardInfo.cardNum" 
                autocomplete="off" 
                @input="clearCNCarNum(1)"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" class="search-btn" @click="addLoyaltyCard">
            {{ $t("MESSAGE.CONFIRMBUTTONTEXT") }}
          </el-button>
          <el-button @click="loyaltyCardInfo.dialogAddLoyaltyCard = false">
            {{ $t("MESSAGE.CONFIRMCANCELTEXT") }}
          </el-button>
        </span>
      </template>
    </el-dialog>
    <CardTypeDialog 
      :centerDialogVisible="dialogValue" 
      :cardType="selectedCardType" 
      :isTemporary ="bookingForm.isTemporary"
      :lKPKID ="bookingForm.lKPKID"
      :loginid ="bookingForm.travelerCode"
      :userid = "bookingCreateParam.RefId"
      @cancelCardTypeDialog="cancelCardTypeDialog" 
      @cardTypeSubmit="handleCardTypeSubmit"></CardTypeDialog>
    <CardTypeDialog 
      :centerDialogVisible="dialogOtherValue" 
      :cardType="selectedOtherCardType" 
      :isTemporary ="bookingForm.bookingFormOther.isTemporary"
      :lKPKID ="bookingForm.bookingFormOther.lKPKID"
      :loginid ="bookingForm.bookingFormOther.travelerCode"
      :userid = "bookingForm.bookingFormOther.RefId"
      @cancelCardTypeDialog="cancelCardTypeOtherDialog" 
      @cardTypeSubmit="handleCardTypeOtherSubmit"></CardTypeDialog>
  </div>
</template>

<script>
import DateRoom from "../../components/DateRoom.vue";
import BookingHeader from "@/views/booking/Booking_Header.vue";
import BookingRight from "@/views/booking/Booking_Right.vue";
import {
  travelerLookup,
  getCustomerMI,
  getTemporaryGuestList,
  getLoyaltyCardInfo,
  getExchangerate,
  getuatp,
  getCostCenter,
} from "../../api/platformData.js";
import {
  getHotelgroupInfo,getcountryList,
} from "../../api/shoppingData.js";
import {
  createBooking,
  bookingsPropertyRate,
  verifyRepeatOrder,
  getConsul,
  toPinyin,
} from "../../api/bookingData.js";
import {
  addLoyaltyCard,
  editLoyaltyCard
} from "../../api/profileData.js";
import {
  formatDateTime,
  getArriveTime,
  getSpecialRoom,
  getSpecialSabreRoom,
  getSpecialBed,
  getSpecialSabreBed,
  isLocation,
  isEnglishAndOtherTwo,
  codeIsCode,
  _debounce,
  isCityGAT,
  eval2,
} from "../../utils/utils.js";
import ConfirmBoxs from "../../components/confirmBoxs.vue";
import Loading from "@/components/Loading.vue";
import CardTypeDialog from "@/components/CardTypeDialog.vue";
// import RoomNum from "./RoomNum.vue";
// import BookCustom from "./BookCustom.vue";
import { hideElement, isEnglishAndOther, isChinese, getCityInfoByCode } from "@/utils/utils.js";

export default {
  name: "Booking",
  components: {
    DateRoom,
    ConfirmBoxs,
    Loading,
    BookingHeader,
    BookingRight,
    CardTypeDialog,
  },
  provide() {
    return {
      ParentData: this,
    }
  },
  data() {
    //持卡人姓名正则 英文
    var validatePass = (rule, value, callback) => {
      if (this.bookingCreateParam.source && (this.bookingCreateParam.source.indexOf("sabre") > -1 || this.bookingCreateParam.source.indexOf("booking") > -1)) {
        if (!isEnglishAndOtherTwo(value)) {
          callback(new Error(this.$t("BOOKING.GUESTNAMERULESABRE")));
        } else {
          callback();
        }
      } else if (this.$i18n.locale == "en") {
        //英文 必须是全英加空格
        if (!isEnglishAndOther(value)) {
          callback(new Error(this.$t("BOOKING.GUESTNAMERULE")));
        } else {
          callback();
        }
      }
      else if(this.$objBaseInfo.destinationType=="I")
      {//国际订单必须使用英文
        if (!isEnglishAndOtherTwo(value)) {
          callback(new Error(this.$t("BOOKING.GUESTNAMERULESABRE")));
        } else {
          callback();
        }
      }
      else {
        //中文
        if (isEnglishAndOther(value) || isChinese(value)) {
          callback();
        } else {
          callback(new Error(this.$t("BOOKING.GUESTNAMERULE")));
        }
      }
    };
    return {
      eval2:eval2,
      isJugeOut: false, //是否需要判断超标
      dialogOut: false,
      outMsg: "",
      guestNameRule: validatePass,
      newAmount: "", //新价格
      originAmount: "", //原价格
      dialogProceed: false,
      travelerData: [], //行程单出行人数据
      travelerLoading: false,
      dialogTraveler: false,
      isGuestBtn: false, //是否显示添加临客按钮
      isClientTab: false, //是否显示员工列表
      isTempGuest: false, //是否有临客权限
      miLoading: false,
      confirmIcon: "",
      confirmMsg: "", //提示消息内容
      confirmFlag: false, //提示框是否弹出
      isSubmit: true, // 是否允许提交
      pagination: {}, //分页信息
      checked: false,
      originData: [],
      columnLength: 0,
      transData: [],
      originTitle: [],
      showPriceFlag: false,
      hotelTitle: "JW Marriott Hotel Shanghai at Tomorrow Square",
      opt2: [
        {
          value: "1",
          label: "Double Bed",
        },
      ],
      val_opt2: "1",
      bookingForm: {
        name: "",
        mobile: "",
        fmobile: "",
        email: "",
        employeeId: "",
        costCenter: "",
        paymentType: "",
        latestArrivalTime: "",
        dynamically1: "",
        dynamically2: "",
        specialRequests: "",
        travelerCode: "", //出行人code
        POSRCTextValue:"",
        isExceeded:false,
        uatpCardNo:"",//uatp卡号
        costCenterid:0,//成本中心id
        uatpCardValidDate:"",//uatp卡有效期
        supplierAndModel:"",//uatp供应商及模式
        isopenCTA:false,//是否打开CTA
        bookingFormOther: 
        {
          name:"",
          mobile: "",
          fmobile: "",
          email: "",
          linkerEmail:"",
          linkerMobile:"",
          linkerName:"",
          linkerFMobile:"",//联系人真实电话
          birthday:"",//生日
          idCardNumber:"",//身份证号
          passportNumber:"",//护照号
          visaCountry: "",
          sex: "",
          cardType:"NI",//证件类型
          cardTypeNumber:"",
          cardTypeSelectDisabled:false,
          cardTypeButtonDisabled:false,
          showIdNumber:false,
          lKPKID :0,
          isTemporary :false,
          travelerCode: "", //出行人code
        }, //创建订单参数-其他人
        loyaltyCardTypeInput:"",//临客会员卡
        loyaltyCardType:"",//会员卡
        linkerEmail:"",//联系人邮箱
        linkerMobile:"",//联系人电话
        linkerName:"",//联系人姓名
        linkerFMobile:"",//联系人真实电话
        birthday:"",//生日
        idCardNumber:"",//身份证号
        passportNumber:"",//护照号
        visaCountry: "",
        sex: "",
        cardType:"NI",//证件类型
        cardTypeNumber:"",
        cardTypeSelectDisabled:false,
        cardTypeButtonDisabled:false,
        showIdNumber:false,
        lKPKID :0,
        isTemporary :false,
      },
      clientData: [],
      roomNum: ["1"],
      opt3: [],
      opt4: [],
      val_opt3: "",
      val_opt4: "16:00",
      val_opt1: "f",
      dialogUserName: false,
      clientLoading: false, //人员加载等待
      submitLoading: false, //提交等待
      guestData: [],
      activeName: "first",
      searchName: "", //name search
      searchTel: "", //tel search
      choseeTabName: "first", //默认选中的tab的name属性值
      addGuestInfo: {
        guestName: "",
        guestMobile: "",
        guestEmail: "",
      },
      formLabelWidth: "100px",
      dialogAddGuest: false,
      conChecked: false,
      hotelInfo: { hotelName: {}, address: {}, roomName: {} }, //酒店信息
      checkInOutDate: [],
      isGuaranteeRequired: false, //是否担保
      totalPrice: 0, //总价
      miList: [],
      optMi: {},
      cancellationPolicy: {}, //取消政策
      pageParam: {},
      bookingCreateParam: {
        isIntegral:null
      }, //创建订单参数
      dailyPrices: [],
      nameFocus: false, //是否禁用姓名选择
      specialRoomArr: [],
      specialBedArr: [],
      mobileTravelShow: false, //移动端出行人选择弹出层
      mobileNameShow: false, // 移动端临客、员工弹出层
      travelRadio: "",
      clientRadio: "",
      guestRadio: "",
      vantcurrPage: 1,
      mobileTotalNum: 0,
      mobileAddGuestShow: false, // 临客添加
      showMobilePriceFlag: false,
      orderIdTo: "", //订单ID
      orderCityInfo: {}, //城市信息
      
      taxesInfo :{//税费信息
        hasTax: false,
        taxAmount: 0,
        taxCurrency: "",
        taxCurrencyCode:"",
        others: 0,
        otherCurrency:"",
        othersCurrencyCode:"",
      },
      rangeNumber: 200,
      verifyRepeatOrderFlag:false,//验证是否有重复订单
      //isShowTax: true, //是否显示税费
      //isShowOther: true, // 是否显示其他费用
      languageValue: "",
      loyaltyCardInfo:{
        showLoyatyCard: false,
        showInputLoyatyCard: false,
        loyaltyCardOptions: [],
        loyaltyCardType: "",
        loyaltyCardTypeInput: "",
        dialogAddLoyaltyCard: false,
        addLoyaltyCardInfo:{
          cardNum: "",
          groupName: "",
        },
        hotelgroupName:"",
        selectGroupInfo:{},
        hotelgroupsInfo:[],
      },
      isShowPOSRC:false,//是否展示RC超标信息
      POSRCTextList:[],
      mobileRules:[{required: true,message: this.$t('BOOKING.VALIDATEMES2'),trigger: ['blur', 'change'],},],
      otherMobileRules:[{required: true,message: this.$t('BOOKING.VALIDATEMES2'),trigger: ['blur', 'change'],},],
      linkerMobileRules:[{required: true,message: this.$t('BOOKING.VALIDATEMES2'),trigger: ['blur', 'change'],},],
      otherLinkerMobileRules:[{required: true,message: this.$t('BOOKING.VALIDATEMES2'),trigger: ['blur', 'change'],},],
      CityCodes:[],//港澳台城市code
      isCostCenterOpen:false,//是否打开成本中心(是否必填)
      isCostCenterShow:false,//是否展示成本中心
      isCostCenterEdit:false,//是否可以修改成本中心
      isValidUATP:false,//是否验证UATP卡
      isValidExpiredUATP:false,//验证UATP卡是否过期
      costCenterType:"",//成本中心type
      CostCenterList:[],//成本中心列表
      costCenteroptions:[],//成本中心展示列表
      costCenterrangeNumber:50,//成本中心最大展示数量
      isMultiplayerBooking:false,//是否多人预定
      guestCount:1,
      isMajorTravelers:true,//是否主要出行人
      isRepeat:false,//是否重单
      isGuaranteeType:false,//是否需要担保
      isIntegralGroup:false,//是否可积分酒店集团
      isAdd:true,//展示添加会员卡按钮
      loyaltyCardPkid:"",
      intlTaxDisplay:0,
      latestArrivalTimeDisabled:false,
      showLinker:false,
      cardTypeOption:[],
      dialogValue:false,
      dialogOtherValue:false,
      selectedCardType:"",
      selectedOtherCardType:"",
    };
  },
  computed:{
    getPOSRCTextList()
    {
      let arr=[];
      for (let i = 0; i < this.POSRCTextList.length; i++) {
        if(this.$i18n.locale == "en")
        {
            arr.push({code:this.POSRCTextList[i].code,value:this.POSRCTextList[i].enText});
        }
        else
        {
            arr.push({code:this.POSRCTextList[i].code,value:this.POSRCTextList[i].cnText});
        }
      }
      return arr;
    },
    getMINote()
    {
      return (item) => {
        if(item!=null && item!=undefined && item!="")
        {
          if(this.$i18n.locale == "en")
          {
            if(item.noteEN!=undefined && item.noteEN!=null && item.noteEN!="")
            {
              return item.noteEN;
            }
            else
            {
              return "";
            }
          }
          else
          {
            if(item.noteCN!=undefined && item.noteCN!=null && item.noteCN!="")
            {
              return item.noteCN;
            }
            else
            {
              return "";
            }
          }
        }
        else
        {
          return "";
        }
      };
    },
    getMINoteLink()
    {
      return (item) => {
        if(item!=null && item!=undefined && item!="")
        {
          if(this.$i18n.locale == "en")
          {
            if(item.noteENLink!=undefined && item.noteENLink!=null && item.noteENLink!="")
            {
              return item.noteENLink;
            }
            else
            {
              return "javascript:void(0)";
            }
          }
          else
          {
            if(item.noteCNLink!=undefined && item.noteCNLink!=null && item.noteCNLink!="")
            {
              return item.noteCNLink;
            }
            else
            {
              return "javascript:void(0)";
            }
          }
        }
        else
        {
          return "";
        }
      }
    },
    getMINoteShow()
    {
      return (item) => {
        if(item!=null && item!=undefined && item!="")
        {
          if(this.$i18n.locale == "en")
          {
            if(item.noteENLink!=undefined && item.noteENLink!=null && item.noteENLink!="")
            {
              return true;
            }
            else
            {
              return false;
            }
          }
          else
          {
            if(item.noteCNLink!=undefined && item.noteCNLink!=null && item.noteCNLink!="")
            {
              return true;
            }
            else
            {
              return false;
            }
          }
        }
        else
        {
          return false;
        }
      };
    },
    formatMobile() {
      if(this.$objBaseInfo.sourceType == "CRM"){
        return (code) =>{
          if (!code || code.length === 0) {
            return '';
          }
          return `${code}`;
        } 
      }else{
        return (code) => {
          if (!code || code.length === 0) {
            return '';
          }
          return `${code.slice(0, 3)}*****${code.slice(-3)}`;
        }
      }
    },
    specialalert(){
      //非公付 非担保
      return (item) => {
        if (item == 1 && !this.isGuaranteeRequired) 
        {
          if(this.bookingCreateParam.source.indexOf("sabre-oversea") > -1){
            return this.$t("BOOKING.SPECIALALERT4");
          }
          else if(this.bookingCreateParam.source.indexOf("sabre") > -1)
          {
            return this.$t("BOOKING.SPECIALALERT2");
          }
          else
          {
            return this.$t("BOOKING.SPECIALALERT");
          }
          
        }
        //公付
        if(item == 3)
        {
          return this.$t("BOOKING.SPECIALALERT1");
        }
      }
    },
    getCardTypeSelect() {
      return [
        { label: this.$t("cardTypes.IdCard"), value: "NI" },
        { label: this.$t("cardTypes.Passport"), value: "FOID" },
        { label: this.$t("cardTypes.HomeReturnPermit"), value: "RP" },
        { label: this.$t("cardTypes.TaiwanCard"), value: "TCC" },
        { label: this.$t("cardTypes.OfficerCard"), value: "JG" },
        { label: this.$t("cardTypes.HongKongAndMacaoPass"), value: "MP" },
        { label: this.$t("cardTypes.TaiWanPass"), value: "TWP" },
        { label: this.$t("cardTypes.HkAndMacauPass"), value: "GATJZZ" },
        { label: this.$t("cardTypes.ForeignPermanentResidentCard"), value: "PRC" },
      ];

    },
  },
  created() {
    this.opt4 = getArriveTime();
    this.specialRoomArr = getSpecialSabreRoom();
    this.specialBedArr = getSpecialSabreBed();
    if (this.$objBaseInfo.channelId === "MOBILE") {
      this.$nextTick(() => {
        //不显示回退按钮
        let goHistray = document.querySelector(".van-nav-bar__left");
        goHistray.setAttribute("style", "display:none");
      });
    }
    this.getCityConcelValue();
    this.bookingForm.showIdNumber = !this.$objBaseInfo.isComplete;
  },
  updated() {
    this.cardTypeOption = this.getCardTypeSelect;
  },
  mounted() {
    //判断来源 CRM跳转过来隐藏部分元素
    hideElement(this);
    //session取值
    let sessionParam = sessionStorage.getItem("createOrder");
    if (!sessionParam) {
      return false;
    }
    //移除面包屑的样式
    let classList = document.querySelectorAll(".el-breadcrumb__inner");
    for (const iterator of classList) {
      iterator.removeAttribute("class");
    }
    //接受上个页面传入的酒店ID 以及房型ID
    this.pageParam = JSON.parse(sessionParam);
    console.log("pageParam", this.pageParam);
    let detailParam = this.pageParam.bookingCreateParam;
    this.guestCount=this.pageParam.guestCount;
    this.getCountryList(detailParam.hotelInfo.countryCode);
    if(this.$objBaseInfo.destinationType == null || this.$objBaseInfo.destinationType == ''){
      this.$objBaseInfo.destinationType = detailParam.hotelInfo.countryCode == "100000" ? "D" :"I";
    }
    //判断是否多人入住
    if(this.guestCount!=undefined && this.guestCount!=null &&this.guestCount>=2)
    {
      this.isMultiplayerBooking=true;
    }
    if (detailParam != null && detailParam != undefined) {
      this.bookingCreateParam = detailParam;
      this.isIntegralGroup = this.bookingCreateParam.isIntegral;
      this.hotelInfo = this.bookingCreateParam.hotelInfo;
      
      getCityInfoByCode(this.hotelInfo.city).then((city) => {
        if (city) {
          this.orderCityInfo = city;
        }
      });
      this.totalPrice = parseFloat(parseFloat(this.bookingCreateParam.totalPrice).toFixed(2));
      this.originData = this.bookingCreateParam.originData;
      this.dailyPrices = this.bookingCreateParam.dailyPrices;
      this.isGuaranteeRequired = this.bookingCreateParam.isGuaranteeRequired;
      this.cancellationPolicy = this.bookingCreateParam.cancellationPolicy;
      this.opt3.push(this.bookingCreateParam.paymentType);
      this.bookingForm.paymentType = this.bookingCreateParam.paymentType;
      this.bookingCreateParam.bookingType = this.bookingCreateParam.bookingType
        ? this.bookingCreateParam.bookingType.trim() : "";
      if (this.$objBaseInfo.destinationType == "I" || this.$objBaseInfo.isGATCity) {
        if (JSON.stringify(this.bookingCreateParam.taxes) !== "{}") {
          this.taxesInfo.taxAmount = this.bookingCreateParam.taxes.amount;
          this.taxesInfo.taxCurrency = this.bookingCreateParam.taxes.currencyCode ? this.$currencySign[this.bookingCreateParam.taxes.currencyCode] : "";
          this.taxesInfo.taxCurrencyCode = this.bookingCreateParam.taxes.currencyCode;
          this.taxesInfo.hasTax = true;
        }
        if (JSON.stringify(this.bookingCreateParam.fees) !== "{}") {
          this.taxesInfo.others = this.bookingCreateParam.fees.amount;
          this.taxesInfo.otherCurrency = this.bookingCreateParam.fees.currencyCode ? this.$currencySign[this.bookingCreateParam.fees.currencyCode] : ""
          this.taxesInfo.othersCurrencyCode = this.bookingCreateParam.fees.currencyCode;
          this.taxesInfo.hasTax = true;
        }
      }
      this.latestArrivalTimeDisabled = !this.isGuaranteeRequired && this.bookingCreateParam.source.indexOf("sabre") == -1 
            && this.bookingCreateParam.paymentType==1 ? true : false;
    } else {
      return false;
    }
    this.checkIsShowLoyatyCard();
    let checkInOutDates = [];
    this.pageParam.checkInAt = formatDateTime(this.pageParam.checkInAt,"YYYY-MM-DD");
    this.pageParam.checkOutAt = formatDateTime(this.pageParam.checkOutAt,"YYYY-MM-DD");
    checkInOutDates.push(this.pageParam.checkInAt);
    checkInOutDates.push(this.pageParam.checkOutAt);
    if (
      (new Date(this.pageParam.checkOutAt).getTime() -
        new Date(this.pageParam.checkInAt).getTime()) /
        (3600 * 1000 * 24 * 1) >
      this.$objBaseInfo.maxNights
    ) {
      this.confirmFlag = true;
      this.confirmMsg = this.$t("SEARCH.CHECKINOUTDATE", {
        maxDay: this.$objBaseInfo.maxNights,
      });
      this.isSubmit = false;
      return false;
    }
    this.checkInOutDate = checkInOutDates;
    // this.getHotelDetail(this.pageParam);
    if (this.$objBaseInfo.extraBooking == 1) {
      this.isTempGuest = true;
    } else {
      if(this.$objBaseInfo.sourceType == 'CRM')
      {
         this.isTempGuest = true;
      }
      else
      {
         this.isTempGuest = false;
      }
    }
    //2: Arranger 1:Traveler
    if (
      this.$objBaseInfo.ordApprovalType == 1 &&
      this.$objBaseInfo.tripOrderInfo != null &&
      this.$objBaseInfo.tripOrderInfo != undefined
    ) {
      // 行前审批 弹框选择出行人
      this.travelerData = this.$objBaseInfo.tripOrderInfo.travelers;
      this.nameFocus = false;
    } else {
      //非行前审批 或者 白名单
      if (
        this.$objBaseInfo.hotelBookingRole == 2 ||
        this.$objBaseInfo.hotelBookingRole == 3
      ) {
        this.isClientTab = true;
        // 根据view权限获取员工信息
        this.getTraveler(1);
      } else {
        //是否允许弹出选择出行人
        if (this.isTempGuest) {
          this.nameFocus = false;
          if(this.$objBaseInfo.sourceType == 'CRM')
          {
              this.isClientTab = true;
          }
          else
          {
            this.isClientTab = false;
          }
          this.activeName = "second";
          if (this.$objBaseInfo.channelId == "WEB") {
            this.choseeTab("second");
          } else {
            this.choseeMobileTab("second");
          }
        } else {
          this.nameFocus = true;
        }
        const linkerValue = sessionStorage.getItem('linkerValue');
        if(linkerValue == 1){
          
          this.showLinker = true;
          this.bookingForm.linkerEmail = this.$objBaseInfo.linkerEmail;
          this.bookingForm.linkerMobile = this.$objBaseInfo.linkerMobile;
          this.bookingForm.linkerName = this.$objBaseInfo.linkerName;
        }
        //默认登陆人
        this.bookingForm.name = this.$objBaseInfo.userName;
        this.bookingForm.namePinyin = this.$objBaseInfo.userNameQuanPin;
        this.bookingForm.mobile = this.$objBaseInfo.mobilePhone;
        this.bookingForm.email = this.$objBaseInfo.eMail;
        this.bookingForm.birthday = this.$objBaseInfo.birthday;
        this.bookingForm.idCardNumber = this.$objBaseInfo.idCardNumber;
        this.bookingForm.passportNumber = this.$objBaseInfo.passportNumber;
        this.bookingForm.visaCountry = this.$objBaseInfo.visaCountry;
        this.bookingForm.sex = this.$objBaseInfo.sex;
        this.bookingForm.employeeId = this.$objBaseInfo.staffNum;
        this.bookingForm.costCenter = this.$objBaseInfo.costCenterID;
        this.bookingForm.travelerCode = this.$objBaseInfo.loginID;
        this.bookingCreateParam.isEmployee = true;
        this.bookingCreateParam.userLevel = this.$objBaseInfo.userLevel;
        this.bookingCreateParam.departmentCode = this.$objBaseInfo.departmentCode;
        this.bookingCreateParam.departmentName = this.$objBaseInfo.departmentName;
        this.bookingCreateParam.RefId = this.$objBaseInfo.pkid;

        //超标 获取超标的
        if (this.pageParam.isOut) {
          this.getMiList("W");
        } else {
          this.getMiList("N");
        }
        this.languageValue = this.$objBaseInfo.sourceType == "OBT"? this.$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE") : (this.$objBaseInfo.languageValue == "CN" ? "zh-CN" : this.$objBaseInfo.languageValue);
      }
    }
    if(this.bookingForm.name!= "" && this.bookingForm.name!= null)
    {
      this.loyaltyCardInfo.showLoyatyCard = true;
      this.getLoyaltyCard();
    }else{
      this.bookingForm.showIdNumber = false;
    }
    this.bookingForm.latestArrivalTime = "18:00";   //将默认入住时间改为18:00 默认需要担保
    this.LatestArrivalTimeChange(this.bookingForm.latestArrivalTime);
    this.LoadRC();
    this.LoadCostCenter();//加载成本中心配置
  },
  watch: {
    "$i18n.locale"() {
      this.$refs["bookingForm"].clearValidate();
    },
    dialogAddGuest(newVal) {
      if (!newVal) {
        this.$refs["addGuestInfo"].resetFields();
      }
    },
    mobileAddGuestShow(newVal) {
      if (!newVal) {
        this.addGuestInfo.guestName = "";
        this.addGuestInfo.guestMobile = "";
        this.addGuestInfo.guestEmail = "";
        this.$nextTick(() => {
          const mobileAddGuestForm = this.$refs["mobileAddGuestForm"];
          if (mobileAddGuestForm && typeof mobileAddGuestForm.resetValidation === "function") {
            mobileAddGuestForm.resetValidation();
          }
        });
      }
    },
  },
  methods: {
    // 移动端持卡人姓名正则 英文
    mobileGuestPass(value) {
      if (this.bookingCreateParam.source && (this.bookingCreateParam.source.indexOf("sabre") > -1 || this.bookingCreateParam.source.indexOf("booking") > -1)) {
        if (!isEnglishAndOtherTwo(value)) {
          return false;
        } else {
          return true;
        }
      } else if (this.$i18n.locale == "en") {
        //英文 必须是全英加空格
        if (!isEnglishAndOther(value)) {
          return false;
        } else {
          return true;
        }
      }
      else if(this.$objBaseInfo.destinationType=="I")
      {//国际订单必须使用英文
        if (!isEnglishAndOtherTwo(value)) {
          return false;
        } else {
          return true;
        }
      }
      else {
        //中文
        if (isEnglishAndOther(value) || isChinese(value)) {
          return true;
        } else {
          return false;
        }
      }
      // if (this.$i18n.locale == "en") {
      //   //英文 必须是全英加空格
      //   if (!isEnglishAndOther(val)) {
      //     return false;
      //   } else {
      //     return true;
      //   }
      // } else {
      //   //中文
      //   if (isEnglishAndOther(val) || isChinese(val)) {
      //     return true;
      //   } else {
      //     return false;
      //   }
      // }
    },
    // 移动端选择员工
    choseeClient(item) {
      this.mobileNameShow = false;
      this.clientRadio = item.travelerCode;
      this.guestRadio = "";
      this.selectTraveler(item);
    },
    // 移动端选择临客
    choseeGuest(item) {
      this.mobileNameShow = false;
      this.clientRadio = "";
      this.guestRadio = item.pkId;
      this.selectTraveler(item);
    },
    // 移动端选择出行人
    choseeTravel(item) {
      this.mobileTravelShow = false;
      this.travelRadio = item.employeeID;
      this.selectTravelerName(item);
    },
    //继续预订
    continueBook() {
      this.dialogProceed = false;
      if (this.isJugeOut) {
        this.isJugeOut = false;
        this.dialogOut = true;
        return false;
      }
      this.dialogOut = false;
      //超标 允许预订
      this.isSubmit = true;
      this.getMiList("W");
    },
    //取消预订
    cancleBook() {
      this.dialogOut = false;
      this.dialogProceed = false;
      this.isSubmit = false;
      //清空MI
      this.miList = [];
    },
    selectTravelerName(item) {
      this.dialogTraveler = false;
      this.submitLoading = true;
      this.setTraveler(item);
    },
    //行程单入住人选择
    async setTraveler(item) {
      let travelerParam = {
        params: {
          companyCode: this.$objBaseInfo.customerCode,
          userId: item.userID == "0"? this.$objBaseInfo.pkid : item.userID,
        },
      };
      await travelerLookup(travelerParam)
        .then((res) => {
          if (res.code == 200) {
            if (res.data.error.code != 0) {
              this.submitLoading = false;
              this.confirmFlag = true;
              this.confirmMsg =
                this.$t("ERRORMESSAGE." + res.data.error.code) ===
                "ERRORMESSAGE." + res.data.error.code
                  ? this.$t("ERRORMESSAGE.NOTFOUND")
                  : this.$t("ERRORMESSAGE." + res.data.error.code);
              console.log(
                "行程单入住人信息请求失败,code:" + res.data.error.code,
                res.data.error.message
              );
              this.isSubmit = false;
            } else {
              let traveler = res.data.travelerList[0];
              // 判断是否为白名单 以及目的地判断 如果是弱管控 不判断
              if (
                !traveler.isWhiteList &&
                !isLocation(
                  this.$objBaseInfo.tripOrderInfo.location,
                  this.hotelInfo.city
                ) && this.$objBaseInfo.strongControl == 1
              ) {
                this.confirmMsg = this.$t("BOOKING.TRIPSELECTGUEST");
                this.isSubmit = false;
                this.confirmFlag = true;
                this.submitLoading = false;
              } else {
                if(this.isMajorTravelers){//判断是否为主要入出行人
                  this.bookingForm.name = item.userName;
                  this.bookingForm.namePinyin = traveler.userNameQuanPin;
                  this.bookingForm.mobile = item.mobile;
                  this.bookingForm.email = item.email;
                  this.bookingForm.birthday =  item.birthday ?? "";
                  this.bookingForm.idCardNumber =  item.idCardNumber ?? "";
                  this.bookingForm.passportNumber =  item.passportNumber ?? "";  
                  this.bookingForm.visaCountry =  item.visaCountry ?? "";  
                  this.bookingForm.sex =  item.sex ?? "";               
                  this.bookingForm.employeeId = item.employeeID;
                  this.bookingForm.costCenter = item.costCenter;
                  this.bookingForm.travelerCode = traveler.travelerCode;
                  this.bookingCreateParam.userLevel = traveler.userLevel;
                  this.bookingCreateParam.departmentCode = traveler.departmentID
                    ? traveler.departmentID.toString() : "";
                  this.bookingCreateParam.departmentName = traveler.departmentName;
                  this.bookingCreateParam.isEmployee = true;
                  this.bookingCreateParam.RefId = traveler.pkId;
                  this.languageValue = traveler.languageValue == "CN" ? "zh-CN" : traveler.languageValue;

                  const linkerValue = sessionStorage.getItem('linkerValue');
                  if(linkerValue == 1){
                    this.showLinker = true;
                    this.bookingForm.linkerEmail = "";
                    this.bookingForm.linkerMobile = "";
                    this.bookingForm.linkerName = "";
                  }
                  this.bookingPrecheck(); //预检
                }else{
                  this.bookingForm.bookingFormOther.name = item.userName;
                  this.bookingForm.bookingFormOther.namePinyin = traveler.userNameQuanPin;
                  this.bookingForm.bookingFormOther.mobile = item.mobile;
                  this.bookingForm.bookingFormOther.email = item.email;
                  this.bookingForm.bookingFormOther.employeeId = item.employeeID;
                  this.bookingForm.bookingFormOther.costCenter = item.costCenter;
                  this.bookingForm.bookingFormOther.travelerCode = traveler.travelerCode;
                  this.bookingForm.bookingFormOther.isEmployee = false;
                  this.bookingForm.bookingFormOther.userLevel = traveler.userLevel;
                  this.bookingForm.bookingFormOther.departmentCode = traveler.departmentID
                  ? traveler.departmentID.toString() : "";
                  this.bookingForm.bookingFormOther.departmentName = traveler.departmentName;
                  this.bookingForm.bookingFormOther.RefId = traveler.pkId;
                  const linkerValue = sessionStorage.getItem('linkerValue');
                  if(linkerValue == 1){
                    this.showLinker = true;
                    this.bookingForm.bookingFormOther.linkerEmail = "";
                    this.bookingForm.bookingFormOther.linkerMobile = "";
                    this.bookingForm.bookingFormOther.linkerName = "";
                  }
                  this.submitLoading = false;
                }
                
              }
            }
          } else {
            this.submitLoading = false;
            this.isSubmit = false;
            this.confirmFlag = true;
            this.confirmMsg =
              this.$t("ERRORMESSAGE." + res.code) === "ERRORMESSAGE." + res.code
                ? this.$t("ERRORMESSAGE.NOTFOUND")
                : this.$t("ERRORMESSAGE." + res.code);
            console.log(
              "行程单入住人信息请求错误,code:" + res.code,
              res.message
            );
          }
        })
        .catch(function (error) {
          this.submitLoading = false;
          this.isSubmit = false;
          this.confirmFlag = true;
          this.confirmMsg = this.$t("ERRORMESSAGE." + error.mesCode);
          console.log("行程单入住人信息请求错误", error.objError);
        });
    },
    //关闭name校验输入框
    nameDialogClose(done) {
      done(); //关闭弹框
      try
      {
        this.$refs["bookingForm"].validate((valid) =>{
          if (!valid) {
            return false;
          }
        });
      }
      catch(error) {
          console.log("error", error);
      };
    },
    setConfirmFlag() {
        this.confirmFlag = false;
        if (this.orderIdTo != "") {
          this.toConfirmation(this.orderIdTo);
        }
    },
    //分页切换
    pageChange(currPage) {
      if (this.choseeTabName === "first") {
        this.getTraveler(currPage);
      } else {
        this.getTravelerTemp(currPage);
      }
    },
    addGuest() {
      if (this.$objBaseInfo.channelId == "WEB") {
        this.$refs["addGuestInfo"].validate((valid) => {
          if (valid) {
            this.guestInfo();
          } else {
            return false;
          }
        });
      } else {
        this.mobileAddGuestShow = false;
        this.guestInfo();
      }
    },
    guestInfo() {
      const linkerValue = sessionStorage.getItem('linkerValue');
      if(linkerValue == 1){
        this.showLinker = true;
        this.bookingForm.linkerEmail = "";
        this.bookingForm.linkerMobile = "";
        this.bookingForm.linkerName = "";
      }
      if(this.isMajorTravelers)//判断是否为主要入出行人
      {
        this.bookingForm.name = this.addGuestInfo.guestName.trim();
        this.bookingForm.namePinyin = "";
        this.bookingForm.mobile = this.addGuestInfo.guestMobile.trim();
        this.bookingForm.email = this.addGuestInfo.guestEmail.trim();
        this.bookingForm.birthday = "";
        this.bookingForm.idCardNumber = "";
        this.bookingForm.passportNumber = "";
        this.bookingForm.visaCountry =  "";  
        this.bookingForm.sex = "";       
        this.bookingForm.employeeId = "";
        this.bookingForm.costCenter = "";
        //如果是临客 code赋值为登录人loginId
        this.bookingForm.travelerCode = this.$objBaseInfo.loginID;
        this.bookingCreateParam.isEmployee = false;
        this.bookingCreateParam.userLevel = "";
        this.bookingCreateParam.departmentCode = "";
        this.bookingCreateParam.departmentName = "";

        this.bookingCreateParam.RefId = this.$objBaseInfo.pkid;
        this.dialogAddGuest = false;
        this.languageValue = this.$objBaseInfo.sourceType == "OBT"? this.$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE") : (this.$objBaseInfo.languageValue == "CN" ? "zh-CN" : this.$objBaseInfo.languageValue);
        // 添加临客时，显示会员卡框
        this.loyaltyCardInfo.showLoyatyCard = false;
        this.loyaltyCardInfo.showInputLoyatyCard = true;
        this.bookingForm.showIdNumber = true;
        this.bookingForm.lKPKID = 0;
        this.bookingForm.isTemporary = true;
        this.bookingPrecheck(); //预检
      }
      else
      {
        this.bookingForm.bookingFormOther.name = this.addGuestInfo.guestName.trim();
        this.bookingForm.bookingFormOther.namePinyin = "";
        this.bookingForm.bookingFormOther.mobile = this.addGuestInfo.guestMobile.trim();
        this.bookingForm.bookingFormOther.email = this.addGuestInfo.guestEmail.trim();
        this.bookingForm.bookingFormOther.employeeId = "";
        this.bookingForm.bookingFormOther.costCenter = "";
        //如果是临客 code赋值为登录人loginId
        this.bookingForm.bookingFormOther.travelerCode = this.$objBaseInfo.loginID;
        this.bookingForm.bookingFormOther.isEmployee = false;
        this.bookingForm.bookingFormOther.userLevel = "";
        this.bookingForm.bookingFormOther.departmentCode = "";
        this.bookingForm.bookingFormOther.departmentName = "";
        this.bookingForm.bookingFormOther.birthday = "";
        this.bookingForm.bookingFormOther.idCardNumber = "";
        this.bookingForm.bookingFormOther.passportNumber = "";
        this.bookingForm.bookingFormOther.visaCountry =  "";  
        this.bookingForm.bookingFormOther.sex = "";       
        this.bookingForm.bookingFormOther.RefId = this.$objBaseInfo.pkid;
        this.dialogAddGuest = false;
        this.bookingForm.bookingFormOther.showIdNumber = true;
        this.bookingForm.bookingFormOther.lKPKID = 0;
        this.bookingForm.bookingFormOther.isTemporary = true;
      }
    },
    //动态MI下拉框
    miDropChange(val1, item) {
      this.bookingForm[item.relationMIKey] = val1;
      if (item.textTypeCode === "down") {
        let obj = item.dropDowns.find((e) => {
          return e.downCode === val1;
        });
        this.bookingForm[item.relationMIKey + "Name"] =
          this.$i18n.locale == "zh" ? obj.miNameCN : obj.miNameEN;
      }
      this.$forceUpdate();
    },
    //MI信息获取
    async getMiList(hotelMIControl) {
      //获取MI信息
      let miParams = {
        params: {
          customerCode: this.$objBaseInfo.userCode,
          flitProType: this.$objBaseInfo.destinationType == "D" ? "JD" : "JI",
        },
      };
      await getCustomerMI(miParams)
        .then((res) => {
          this.submitLoading = false;
          if (res.code === 200) {
            if (res.data.error.code != 0) {
              this.confirmFlag = true;
              this.confirmMsg =
                this.$t("ERRORMESSAGE." + res.data.error.code) ===
                "ERRORMESSAGE." + res.data.error.code
                  ? this.$t("ERRORMESSAGE.NOTFOUND")
                  : this.$t("ERRORMESSAGE." + res.data.error.code);
              console.log(
                "MI信息获取失败,code:" + res.data.error.code,
                res.data.error.message
              );
              this.isSubmit = false;
            } else {
              this.miList = [];
              const miListALl = res.data.items;
              if (miListALl.length > 0) {
                for (const key in miListALl) {
                  const element = miListALl[key];
                  if (
                    element.pageShow === 1 &&
                    element.hotelMIControl.indexOf(hotelMIControl) > -1
                  ) {
                    this.miList.push(element);
                  }
                  if (element.textTypeCode === "down") {
                    for (const dropKey in element.dropDowns) {
                      const drop = element.dropDowns[dropKey];
                      if (drop.isDefault === 1) {
                        this.bookingForm[element.relationMIKey] = drop.downCode;
                        break;
                      }
                    }
                  }
                }
              }
            }
          } else {
            this.confirmFlag = true;
            this.confirmMsg =
              this.$t("ERRORMESSAGE." + res.code) === "ERRORMESSAGE." + res.code
                ? this.$t("ERRORMESSAGE.NOTFOUND")
                : this.$t("ERRORMESSAGE." + res.code);
            console.log("MI信息获取失败, code:" + res.code, res.message);
            this.isSubmit = false;
          }
        })
        .catch((err) => {
          this.submitLoading = false;
          this.isSubmit = false;
          this.confirmFlag = true;
          this.confirmMsg = this.$t("ERRORMESSAGE." + err.mesCode);
          console.log("MI信息获取异常", err.objError);
        });
    },
    //预检接口
    async bookingPrecheck() {
      this.submitLoading = true;
      //每天价格
      let priceCalendar = [];
      for (const iterator of this.dailyPrices) {
        priceCalendar.push({
          date: iterator.StayDate,
          amount: iterator.Price,
          breakfastQty: this.bookingCreateParam.breakfastNum,
          publishedFare: iterator.PublishedFare,
        });
      }
      let perParam = {
        posCode: this.$objBaseInfo.poscode,
        hotelCode: this.pageParam.hotelcode,
        roomTypeCode: this.pageParam.roomTypeId,
        ratePlanCode: this.bookingCreateParam.RatePlanCode,
        checkInDate: this.pageParam.checkInAt,
        checkOutDate: this.pageParam.checkOutAt,
        priceCalendar: priceCalendar,
        paymentType: this.bookingCreateParam.paymentType,
        priceType: this.bookingCreateParam.priceType,
        noGuests: this.pageParam.guestCount,
        noRooms: this.pageParam.roomCount,
        breakfastQty: this.bookingCreateParam.breakfastNum,
        currencyCode: this.$objBaseInfo.defaultCurrencyCode,
        bookingContactId: this.$objBaseInfo.loginID,
        guestId: this.bookingForm.travelerCode,
        isEmployee: this.bookingCreateParam.isEmployee,
        provinceCode: this.$objBaseInfo.provinceCode, //省份code
        isDomestic: this.$objBaseInfo.destinationType == "D" ? true : false, //是否是国内
        priceTripRuleType: this.bookingCreateParam.priceTripRuleType,
        standardStar:this.bookingCreateParam.hotelInfo.standardStar,
      };
      await bookingsPropertyRate(perParam)
        .then((res) => {
          this.submitLoading = false;
          if (res.code === 200) {
            this.bookingCreateParam.isOutOfPolicy = res.data.isOutOfPolicy;
            // sabre资源,订单预检获取RateId，提供给下单接口，加速下单
            var rateIdAccess =  res.data.ratePlanID || '';
            this.bookingCreateParam.rateId = rateIdAccess;
            if (res.data.isOutOfPolicy) {
              //超标提示信息
              let star = "";
              let amount = "";
              let cwtTrip = false;
              var negotiationPrice = false ;
              this.outMsg = "";
              for (const item of res.data.outOfPolicyReasons) {
                if (item.key == "amountTopLimit") {
                  amount = this.$objBaseInfo.defaultCurrencySign + item.value;
                }
                else if(item.key == "NegotiationPrice"){
                  negotiationPrice = true;
                }
                else if(item.key == "cwtTrip"){
                  cwtTrip = true;
                } 
                else {
                  star = item.value;
                }
              }
              if (star != "") {
                this.outMsg += this.$t("BOOKING.EXCEEDEDPSTAR", {
                  star: star,
                });
              } else if (amount != "") {
                // this.outMsg += this.$t("BOOKING.EXCEEDEDPRICE", {
                //   price: amount,
                // });
                if(Object.prototype.hasOwnProperty.call(res.data, "rawOverStandardRules")) 
                {
                  let rawAmountTopLimit='';
                  let rawCurrencyCode='';
                  for (const item of res.data.rawOverStandardRules) {
                    if (item.key == "amountTopLimit") {
                      rawAmountTopLimit = item.value;
                    }else if(item.key == "currencyCode"){
                      rawCurrencyCode = item.value;
                    }
                  }
                  if(rawAmountTopLimit!='' && rawCurrencyCode!='')
                  {
                    this.outMsg += this.$t("BOOKING.EXCEEDEDPRICE", {
                      price: this.$currencySign[rawCurrencyCode] + rawAmountTopLimit,
                    });
                  }
                  else
                  {
                      this.outMsg += this.$t("BOOKING.EXCEEDEDPRICE", {
                        price: this.$objBaseInfo.defaultCurrencySign + amount,
                      });
                  }
                }
                else
                {
                    this.outMsg += this.$t("BOOKING.EXCEEDEDPRICE", {
                      price: this.$objBaseInfo.defaultCurrencySign + amount,
                    });
                }
              }
              else if (cwtTrip) {
                this.outMsg = this.$t("RESULT.OUTOFPOLICYTIPEMPTY");
              }
              if(negotiationPrice){
                this.outMsg += (amount != "" ?"<br />":"" ) + this.$t('RESULT.OUTOFPOLICYTIP3');
              }
            }
            if (res.data.error.code === 10902) {
              //价格变化
              if (
                (res.data.isOutOfPolicy && res.data.bookingIsAllowed) ||
                !res.data.isOutOfPolicy
              ) {
                if (res.data.isOutOfPolicy) {
                  this.isJugeOut = true;
                } else {
                  this.isJugeOut = false;
                }
                let isPublicChange = false;
                for (const price of priceCalendar) {
                  let priceNew = res.data.priceCalendar.find((newPrice) => {
                    if (
                      newPrice.date == price.date &&
                      newPrice.publishedFare != price.publishedFare
                    ) {
                      return newPrice;
                    } else {
                      return null;
                    }
                  });
                  if (priceNew) {
                    isPublicChange = true;
                    this.newAmount = this.$objBaseInfo.defaultCurrencySign + priceNew.amount;
                    this.originAmount = this.$objBaseInfo.defaultCurrencySign + price.amount;
                    break;
                  }
                }
                //价格变化 更新价格
                this.totalPrice = 0;
                this.originData = [];
                let oldStayPrice = this.bookingCreateParam.dailyPrices;
                this.dailyPrices = [];
                for (const element of res.data.priceCalendar) {
                  let tax = oldStayPrice.find(
                    (oldprice) => oldprice.date === element.date
                  );
                  let price = {
                    date: element.date,
                    price: this.$objBaseInfo.defaultCurrencySign + element.publishedFare,
                  };
                  if (this.$objBaseInfo.destinationType == "I" || this.$objBaseInfo.isGATCity) {
                    price.tax = tax && tax.taxAmount && tax.taxAmount.amount ? (this.$currencySign[tax.taxAmount.currencyCode] + tax.taxAmount.amount) : "";
                    price.fee = tax && tax.feeAmount && tax.feeAmount.amount ? (this.$currencySign[tax.feeAmount.currencyCode] + tax.feeAmount.amount) : "";
                  }
                  this.originData.push(price);
                  this.totalPrice += parseFloat(element.publishedFare);
                  let daily = {
                    StayDate: element.date,
                    Price: element.amount,
                    CurrencyCode: this.$objBaseInfo.defaultCurrencyCode,
                    PublishedFare: element.publishedFare,
                    // Taxs: {
                    //   Amount: tax && tax.taxAmount && tax.taxAmount.amount ? tax.taxAmount.amount.toString() : null,
                    //   CurrencyCode: tax && tax.taxAmount ? tax.taxAmount.currencyCode : null,
                    // },
                    // OtherFees: {
                    //   Amount: tax && tax.feeAmount && tax.feeAmount.amount ? tax.feeAmount.amount.toString() : null,
                    //   CurrencyCode: tax && tax.feeAmount ? tax.feeAmount.currencyCode : null,
                    // },
                  };
                  this.dailyPrices.push(daily);
                }
                if (isPublicChange) {
                  this.dialogProceed = true;
                }
              } else {
                //超标 不允许预订
                this.isSubmit = false;
                this.confirmFlag = true;
                this.confirmMsg = this.$t("RESULT.OUTOFPOLICYTIPAdd",{outOfPolicy: this.outMsg});
                //清空MI
                this.miList = [];
              }
            } else if (res.data.error.code === 10901) {
              //库存不足
              //不允许超标  不允许提交
              this.isSubmit = false;
              this.confirmFlag = true;
              this.confirmMsg = this.$t("ERRORMESSAGE." + res.data.error.code);
            } else if (res.data.error.code != 0) {
              this.confirmFlag = true;
              this.confirmMsg =
                this.$t("ERRORMESSAGE." + res.data.error.code) ===
                "ERRORMESSAGE." + res.data.error.code
                  ? this.$t("ERRORMESSAGE.NOTFOUND")
                  : this.$t("ERRORMESSAGE." + res.data.error.code);
              console.log(
                "预检接口请求失败, code:" + res.data.error.code,
                res.data.error.message
              );
              this.isSubmit = false;
            } else {
              //判断是否超标
              if (res.data.isOutOfPolicy) {
                if(this.$objBaseInfo.sourceType == "OBT") {
                  if (res.data.bookingIsAllowed) {
                    //超标允许预订
                    this.dialogOut = true;
                  } else {
                    //超标不允许预订
                    this.isSubmit = false;
                    this.confirmFlag = true;
                    this.confirmMsg = this.$t("RESULT.OUTOFPOLICYTIPAdd",{outOfPolicy: this.outMsg});
                    //清空MI
                    this.miList = [];
                  }
                }
                else{
                  if (res.data.bookingIsAllowed || res.data.enableAgentOutOfPolicyControl) {
                    //超标允许预订
                    this.dialogOut = true;
                  } else{
                    //超标不允许预订
                    this.isSubmit = false;
                    this.confirmFlag = true;
                    this.confirmMsg = this.$t("RESULT.OUTOFPOLICYTIPAdd",{outOfPolicy: this.outMsg});
                    //清空MI
                    this.miList = [];
                  }
                }
              } else {
                //未超标
                this.isSubmit = true;
                this.getMiList("N");
              }
            }
          } else {
            this.confirmFlag = true;
            this.confirmMsg = "预检接口返回错误:" + res.message;
          }
        })
        .catch((error) => {
          this.submitLoading = false;
          this.confirmFlag = true;
          this.confirmMsg = "预检接口异常：" + error;
        });
        this.LoadRC();//加载RC信息验证
        this.LoadCostCenter();//加载成本中心配置
    },
    //选择出行人
    selectTraveler(item) {
      if(this.isMajorTravelers)//判断是否为主要入出行人
      {
        if (this.choseeTabName === "first") {
          var isWhiteList = false;
          if (item.isWhiteList) 
          {
            if(item.whiteProduct == undefined || item.whiteProduct == '')
            {
              isWhiteList = true;
            }
            else if(this.$objBaseInfo.destinationType == "I" && item.whiteProduct.includes("InternationalHotel"))
            {
              isWhiteList = true;
            } 
            else if(this.$objBaseInfo.destinationType == "D" && item.whiteProduct.includes("DomesticHotel"))
            {
              isWhiteList = true;
            } 
          }
          if (this.$objBaseInfo.ordApprovalType == 1 && !isWhiteList) {
            // 开启的行前审批 必须选择白名单人员
            this.confirmMsg = this.$t("BOOKING.SELECTTRIPS");
            this.isSubmit = false;
            this.confirmFlag = true;
            return false;
          } else {
            if(this.mobileRules.length > 1){
              this.mobileRules.pop();
            };
            this.dialogUserName = false;
            this.bookingForm.name = item.travelerName;
            this.bookingForm.namePinyin = item.userNameQuanPin;
            this.bookingForm.fmobile = item.mobile;
            this.bookingForm.mobile = this.formatMobile(item.mobile);
            this.bookingForm.email = item.email;
            this.bookingForm.birthday  = item.birthday ?? "";
            if(item.userPaperInfo.isComplete){
              this.bookingForm.showIdNumber = false;
              this.bookingForm.idCardNumber  = item.userPaperInfo.cardID ?? "";
              this.bookingForm.passportNumber  = item.userPaperInfo.cardType ?? "";
              this.bookingForm.visaCountry  = item.userPaperInfo.visaCountry ?? "";
            }else{
              this.bookingForm.showIdNumber = true;
              this.bookingForm.isTemporary  = false;
              this.bookingForm.lKPKID  = 0;
            }
            this.bookingForm.sex  = item.sex ?? "";
            this.bookingForm.employeeId = item.staffNum;
            this.bookingForm.costCenter = item.costCenter;
            this.bookingForm.travelerCode = item.travelerCode;
            this.bookingCreateParam.userLevel = item.userLevel;
            this.bookingCreateParam.departmentCode = item.departmentID;
            this.bookingCreateParam.departmentName = item.departmentName;
            this.bookingCreateParam.isEmployee = true;
            this.bookingCreateParam.RefId = item.pkId;
            this.isSubmit = true;
            this.languageValue = item.languageValue == "CN" ? "zh-CN" : item.languageValue;
            this.loyaltyCardInfo.showLoyatyCard = true;
            this.loyaltyCardInfo.showInputLoyatyCard = false;
            const linkerValue = sessionStorage.getItem('linkerValue');
            if(linkerValue == 1){
              this.showLinker = true;
              this.bookingForm.linkerEmail = item.linkerEmail;
              this.bookingForm.linkerFMobile = item.linkerMobilePhone;
              this.bookingForm.linkerMobile = this.formatMobile(item.linkerMobilePhone);
              this.bookingForm.linkerName = item.linkerName;
            }

            this.getLoyaltyCard()
          }
        } else {
          this.loyaltyCardInfo.showInputLoyatyCard = true;
          this.dialogUserName = false;
          this.bookingForm.name = item.psgName;
          this.bookingForm.namePinyin = "";
          this.bookingForm.mobile = item.mobile;
          this.bookingForm.email = item.email;
          if(item.userPaperInfo.isComplete){
            this.bookingForm.showIdNumber = false;
            this.bookingForm.idCardNumber  = item.userPaperInfo.cardID ?? "";
            this.bookingForm.passportNumber  = item.userPaperInfo.cardType ?? "";
            this.bookingForm.visaCountry  = item.userPaperInfo.visaCountry ?? "";
          }else{
            this.bookingForm.showIdNumber = true;
            this.bookingForm.isTemporary  = true;
            this.bookingForm.lKPKID  = item.pkId;
          }
          this.bookingForm.birthday = item.birthday ?? "";
          this.bookingForm.sex =  item.sex ?? "";
          this.bookingForm.employeeId = "";
          this.bookingForm.costCenter = "";
          this.bookingCreateParam.userLevel = "";
          this.bookingForm.travelerCode = item.loginId ? item.loginId.toString() : "";
          this.bookingCreateParam.departmentCode = "";
          this.bookingCreateParam.departmentName = "";

          this.bookingCreateParam.isEmployee = false;
          this.bookingCreateParam.RefId = item.userID;
          this.languageValue = this.$objBaseInfo.sourceType == "OBT"? this.$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE") : (this.$objBaseInfo.languageValue == "CN" ? "zh-CN" : this.$objBaseInfo.languageValue);
          this.loyaltyCardInfo.showLoyatyCard = false;
          const linkerValue = sessionStorage.getItem('linkerValue');
          if(linkerValue == 1){
            this.showLinker = true;
            this.bookingForm.linkerEmail = "";
            this.bookingForm.linkerMobile = "";
            this.bookingForm.linkerName = "";
          }
        }
        this.bookingPrecheck(); //预检
        console.log("dialogUserName", this.dialogUserName);
      }
      else
      {
        if (this.choseeTabName === "first") 
        {
            if(this.mobileRules.length > 1){
              this.mobileRules.pop();
            };
            this.dialogUserName = false;
            this.bookingForm.bookingFormOther.name = item.travelerName;
            this.bookingForm.bookingFormOther.namePinyin = item.userNameQuanPin;
            this.bookingForm.bookingFormOther.fmobile = item.mobile;
            this.bookingForm.bookingFormOther.mobile = this.formatMobile(item.mobile);
            this.bookingForm.bookingFormOther.email = item.email;
            this.bookingForm.bookingFormOther.employeeId = item.staffNum;
            this.bookingForm.bookingFormOther.costCenter = item.costCenter;
            this.bookingForm.bookingFormOther.travelerCode = item.travelerCode;
            this.bookingForm.bookingFormOther.userLevel = item.userLevel;
            this.bookingForm.bookingFormOther.departmentCode = item.departmentID;
            this.bookingForm.bookingFormOther.departmentName = item.departmentName;
            this.bookingForm.bookingFormOther.birthday = item.birthday ? item.birthday.toString() : "";
            if(item.userPaperInfo.isComplete){
              this.bookingForm.bookingFormOther.showIdNumber = false;
              this.bookingForm.bookingFormOther.idCardNumber  = item.userPaperInfo.cardID ?? "";
              this.bookingForm.bookingFormOther.passportNumber  = item.userPaperInfo.cardType ?? "";
              this.bookingForm.bookingFormOther.visaCountry  = item.userPaperInfo.visaCountry ?? "";
            }else{
              this.bookingForm.bookingFormOther.showIdNumber = true;
              this.bookingForm.bookingFormOther.isTemporary  = false;
              this.bookingForm.bookingFormOther.lKPKID  = 0;
            }
            this.bookingForm.bookingFormOther.sex = item.sex ? item.sex.toString() : "";
            this.bookingForm.bookingFormOther.isEmployee = true;
            this.bookingForm.bookingFormOther.RefId = item.pkId;
            this.isSubmit = true;
            const linkerValue = sessionStorage.getItem('linkerValue');
            if(linkerValue == 1){
              this.showLinker = true;
              this.bookingForm.bookingFormOther.linkerEmail = item.linkerEmail;
              this.bookingForm.bookingFormOther.linkerFMobile = item.linkerMobilePhone;
              this.bookingForm.bookingFormOther.linkerMobile = this.formatMobile(item.linkerMobilePhone);
              this.bookingForm.bookingFormOther.linkerName = item.linkerName;
            }
        } 
        else 
        {
          this.dialogUserName = false;
          this.bookingForm.bookingFormOther.name = item.psgName;
          this.bookingForm.bookingFormOther.namePinyin = "";
          this.bookingForm.bookingFormOther.mobile = item.mobile;
          this.bookingForm.bookingFormOther.email = item.email;
          this.bookingForm.bookingFormOther.employeeId = "";
          this.bookingForm.bookingFormOther.costCenter = "";
          this.bookingForm.bookingFormOther.userLevel = "";
          this.bookingForm.bookingFormOther.travelerCode = item.loginId ? item.loginId.toString() : "";
          this.bookingForm.bookingFormOther.departmentCode = "";
          this.bookingForm.bookingFormOther.departmentName = "";
          this.bookingForm.bookingFormOther.birthday = item.birthday ? item.birthday.toString() : "";
          if(item.userPaperInfo.isComplete){
            this.bookingForm.bookingFormOther.showIdNumber = false;
            this.bookingForm.bookingFormOther.idCardNumber  = item.userPaperInfo.cardID ?? "";
            this.bookingForm.bookingFormOther.passportNumber  = item.userPaperInfo.cardType ?? "";
            this.bookingForm.bookingFormOther.visaCountry  = item.userPaperInfo.visaCountry ?? "";
          }else{
            this.bookingForm.bookingFormOther.showIdNumber = true;
            this.bookingForm.bookingFormOther.isTemporary  = true;
            this.bookingForm.bookingFormOther.lKPKID  = item.pkId;
          }
          this.bookingForm.bookingFormOther.sex = item.sex ? item.sex.toString() : "";
          this.bookingForm.bookingFormOther.isEmployee = false;
          this.bookingForm.bookingFormOther.RefId = item.userID;
          const linkerValue = sessionStorage.getItem('linkerValue');
          if(linkerValue == 1){
            this.showLinker = true;
            this.bookingForm.bookingFormOther.linkerEmail = "";
            this.bookingForm.bookingFormOther.linkerMobile = "";
            this.bookingForm.bookingFormOther.linkerName = "";
          }
        }
      }
    },
    //获取出行人信息
    async getTraveler(currPage) {
      this.execLoading(true);
      let travelerParam = {
        params: {
          page: currPage,
          per_page: 5,
          travelerName: this.searchName,
          mobile: this.searchTel,
          companyCode: this.$objBaseInfo.customerCode,
        },
      };
      console.log(this.$objBaseInfo);
      if (this.$objBaseInfo.bookBy === 1) {
        travelerParam.params.travelerCode = this.$objBaseInfo.bookUserIDs;
        if(travelerParam.params.travelerCode!=undefined && travelerParam.params.travelerCode!=null &&travelerParam.params.travelerCode!=""){
          if(travelerParam.params.travelerCode.indexOf(this.$objBaseInfo.loginID)<0){
            travelerParam.params.travelerCode+=","+this.$objBaseInfo.loginID;
          }
        }else{
          travelerParam.params.travelerCode = this.$objBaseInfo.loginID;
        }
      } else {
        travelerParam.params.deptCode = this.$objBaseInfo.bookDepIDs;
        if(travelerParam.params.deptCode!="ALL"){
          travelerParam.params.travelerCode = this.$objBaseInfo.loginID;
        }
      }
      let that = this;
      await travelerLookup(travelerParam)
        .then((res) => {
          that.execLoading(false);
          if (res.code === 200) {
            if (res.data.error.code != 0) {
              console.log(
                "出行人信息请求错误,code:" + res.data.error.code,
                res.data.error.message
              );
            } else {
              that.pagination.total = res.data.total; //总数
              that.pagination.pageSize = res.data.pageSize;
              that.pagination.currentPage = res.data.pageNumber;
              that.mobileTotalNum = res.data.total;
              that.clientData = res.data.travelerList;
            }
          } else {
            console.log("出行人信息请求错误,code:" + res.code, res.message);
          }
        })
        .catch(function (error) {
          that.execLoading(false);
          console.log("出行人信息请求错误", error.objError);
        });
    },
    //获取临客列表
    async getTravelerTemp(currPage) {
      this.execLoading(true);
      let tempParam = {
        params: {
          page: currPage,
          per_page: 5,
          psgName: this.searchName,
          mobile: this.searchTel,
          userCode: this.$objBaseInfo.customerCode,
          loginId: this.$objBaseInfo.loginID,
        },
      };
      let that = this;
      await getTemporaryGuestList(tempParam)
        .then((res) => {
          that.execLoading(false);
          if (res.code === 200) {
            if (res.data.error.code != 0) {
              console.log(
                "临客信息请求错误,code:" + res.data.error.code,
                res.data.error.message
              );
            } else {
              that.pagination.total = res.data.total; //总数
              that.pagination.pageSize = res.data.pageSize;
              that.pagination.currentPage = res.data.pageIndex;
              that.mobileTotalNum = res.data.total;
              that.guestData = res.data.list;
            }
          } else {
            console.log("临客信息请求错误,code:" + res.code, res.message);
          }
        })
        .catch(function (error) {
          that.execLoading(false);
          console.log("临客信息请求错误", error.objError);
        });
    },
    //下单
    submitBooking: function () {
      this.submitLoading = true;
      //特殊需求
      let specialValue = [];
      let negotiationPriceType=[];//折扣价格
      let exceeded=[];//RC 超标信息
      let bookingType = []; //延时订单
      let cwtMark=[];//酒店打标数据
      let countryCode=[];//国家代码
      let beforeTaxAmountTotal = [];//税前总价
      let intlTaxDisplayInfo = [];//国际酒店额外税费展示
      let roomTypeDescription=[];//saber价格描述
      let productCode= [];//产品代码
      let rdescription = [{"rdescription":this.bookingCreateParam.rdescription}];
      this.$refs["bookingForm"].validate((valid) => {
        if (valid) {
          let miParamList = [];
          //MI信息参数
          for (const key in this.miList) {
            const element = this.miList[key];
            let miParam = {
              miType: 2,
              miNameDic: {
                "en": "",
                "zh-CN": "",
              }
            };
            miParam.miNameDic["en"] = element.miNameEN;
            miParam.miNameDic["zh-CN"] = element.miNameCN;
            miParam.miCode = element.relationMIKey;
            miParam.miKey = element.relationMIKey;
            miParam.miValue = this.bookingForm[element.relationMIKey];

            miParam.noteCN = element.noteCN;
            miParam.noteEN = element.noteEN;
            miParam.noteCNLink = element.noteCNLink;
            miParam.noteENLink = element.noteENLink;
            miParam.isSendHotelItinerary = element.isSendHotelItinerary;
            miParam.miGuid=element.miGuid;
            miParam.isAffterHotelApproval=element.isAffterHotelApproval;
            if(element.textTypeCode=="down")
            {
              let SelectTextDic={"en": "","zh-CN": ""};
              let miText=element.dropDowns.find(o => o.downCode === miParam.miValue);
              if(miText!=undefined && miText!=null)
              {
                SelectTextDic["en"] = miText.nameEN;
                SelectTextDic["zh-CN"] = miText.nameCN;
                miParam.SelectTextDic=SelectTextDic;
              }
            }
            miParamList.push(miParam);
          }

          //成本中心判断
          if(this.isCostCenterOpen)//判断是否打开成本中心
          {
            //判断是否存在成本中心
            if(this.CostCenterList.length==0)
            {
              this.confirmFlag = true;
              this.confirmMsg =this.$t("BOOKING.CostCenterTitle2");
              this.submitLoading = false;
              return;
            }

            //判断是否选择成本中心
            if(this.bookingForm.costCenterid==0)
            {
              this.confirmFlag = true;
              this.confirmMsg =this.$t("BOOKING.CostCenterTitle1");
              this.submitLoading = false;
              return;
            }
            if(this.isValidUATP)//判断是否验证UATP卡卡号
            {
              if(this.bookingForm.uatpCardNo=="")
              {
                this.confirmFlag = true;
                this.confirmMsg =this.$t("BOOKING.CostCenterUATPTitle1");
                this.submitLoading = false;
                return;
              }
              // 需要判断是否cta支付
              if(!this.isopenCTA)
              {
                if(this.bookingForm.uatpCardValidDate=="")//判断是否存在有效期
                {
                  this.confirmFlag = true;
                  this.confirmMsg =this.$t("BOOKING.CostCenterUATPTitle1");
                  this.submitLoading = false;
                  return;
                }
                if(!this.isValidExpiredUATP)
                {
                  this.confirmFlag = true;
                  this.confirmMsg =this.$t("BOOKING.CostCenterUATPTitle2");
                  this.submitLoading = false;
                  return;
                }
              }
              
            }
          }
          if (!isNaN(parseInt(this.bookingForm.specialBed))) {
            specialValue.push(
              this.specialBedArr[this.bookingForm.specialBed].name
            );
          }
          if (!isNaN(parseInt(this.bookingForm.specialRoom))) {
            specialValue.push(
              this.specialRoomArr[this.bookingForm.specialRoom].name
            );
          }
          var isOutOfPolicy = null;
          if(this.bookingCreateParam.isOutOfPolicy != undefined)
          {
            isOutOfPolicy = this.bookingCreateParam.isOutOfPolicy.toString() == "true"? true: false;
          }
          //赋值countryCode
          if(Object.prototype.hasOwnProperty.call(this.orderCityInfo, "countryCode")) 
          {
            let item={"countryCode":this.orderCityInfo.countryCode};
            countryCode.push(item);
          }
          //创建订单请求参数
          if(Object.prototype.hasOwnProperty.call(this.bookingCreateParam, "negotiationPriceType")) 
          //if(this.bookingCreateParam.hasOwnProperty("negotiationPriceType"))
          {
            let item={"negotiationPriceType":this.bookingCreateParam.negotiationPriceType};
            negotiationPriceType.push(item);
          }
          //酒店打标
          if(Object.prototype.hasOwnProperty.call(this.bookingCreateParam, "cwtMark")) //需要改写成这种写法
          //if(this.bookingCreateParam.hasOwnProperty("cwtMark"))
          {
            if(this.bookingCreateParam.cwtMark!=undefined && this.bookingCreateParam.cwtMark!=null)
            {
              let item={"cwtMark":this.bookingCreateParam.cwtMark};
              cwtMark.push(item);
            }
          }
          if (this.bookingCreateParam.bookingType != undefined && this.bookingCreateParam.bookingType!="") {
            let item = { bookingType: this.bookingCreateParam.bookingType };
            bookingType.push(item);
          }
          if(this.bookingCreateParam.beforeTaxAmountTotal){
            let item = { beforeTaxAmountTotal: this.bookingCreateParam.beforeTaxAmountTotal };
            beforeTaxAmountTotal.push(item);
          }

          if(this.intlTaxDisplay){
            let item = { "intlTaxDisplay": this.intlTaxDisplay };
            intlTaxDisplayInfo.push(item);
          }

          if(this.bookingCreateParam.roomTypeDescription){
            let item = { "roomTypeDescription": this.bookingCreateParam.roomTypeDescription };
            roomTypeDescription.push(item);
          }
          
          if(this.bookingCreateParam.productCode){
            let item = { "productCode": this.bookingCreateParam.productCode };
            productCode.push(item);
          }

          if(this.isShowPOSRC)
          {
            if(this.bookingForm.POSRCTextValue!="")
            {
              let text="";
              if(this.POSRCTextList.length>0)
              {
                let RCValue=this.POSRCTextList.find(o => o.code === this.bookingForm.POSRCTextValue);
                if(RCValue!=undefined && RCValue!=null)
                {
                  text=RCValue.cnText+","+RCValue.enText;
                }
              }
              let item={"isExceeded":this.bookingForm.isExceeded,"ReasonCodeValue":this.bookingForm.POSRCTextValue,"ReasonCodeValueText":text};
              exceeded.push(item);
            }
          }
          // 判断defaultCurrencyCode是否存在赋值
          if (this.$objBaseInfo.defaultCurrencyCode==undefined || this.$objBaseInfo.defaultCurrencyCode==null || this.$objBaseInfo.defaultCurrencyCode=="") {
            if (this.dailyPrices.length > 0) {
              this.$objBaseInfo.defaultCurrencyCode = this.dailyPrices[0].CurrencyCode;
            }
          } 
          let customerPhone="";
          let isdomc=this.$objBaseInfo.destinationType;//获取国内国际
          //CHOM-2875:修改获取客户电话的联系方式  优先获取国际的已86开头的标题为海外用户请拨打 的配置项
          let customerInternationalTel=this.$objBaseInfo.customerTcs.filter(item=>item.linkType==1 && 
          item.isDomc.indexOf("I")>=0 && item.keyName.indexOf("海外用户请拨打")>=0 && item.keyValue.indexOf("86")>=0);
          if(customerInternationalTel.length>0)
          {
            if(customerInternationalTel.length==1)
            {
              customerPhone=customerInternationalTel[0].keyValue;
            }
            else if(customerInternationalTel.length>1)
            {
              customerInternationalTel=customerInternationalTel.sort((a,b)=>{ return a.sortId-b.sortId});
              customerPhone=customerInternationalTel[0].keyValue;
            }
          }
          if(customerPhone=="" || customerPhone==undefined || customerPhone==null)
          {
            //elong渠道的订单 获取服务组电话 规则：linkType=1  
            if(this.CityCodes.length>0 && this.CityCodes.indexOf(this.hotelInfo.city)>=0)//港澳台城市当作国内城市判断
            {
              isdomc="I";
            }
            let customerTcsArr=this.$objBaseInfo.customerTcs.filter(item=>item.linkType==1 && item.isDomc.indexOf(isdomc)>=0);
            //if((this.bookingCreateParam.source=="elong" || this.bookingCreateParam.source.indexOf('booking')>=0) && customerTcsArr.length>0)
            if(customerTcsArr.length>0)
            {
              if(customerTcsArr.length==1)
              {
                customerPhone=customerTcsArr[0].keyValue;
              }
              else if(customerTcsArr.length>1)
              {
                customerTcsArr=customerTcsArr.sort((a,b)=>{ return a.sortId-b.sortId});
                customerPhone=customerTcsArr[0].keyValue;
              }
            }
          }
          if(customerPhone !="" && customerPhone !=undefined && customerPhone !=null)
          {
            customerPhone="PH"+customerPhone;
          }
          // if(this.bookingCreateParam.source.indexOf('booking')>=0 && customerTcsArr.length>0)
          // {
          //   if(customerTcsArr.length==1)
          //   {
          //     customerPhone=customerTcsArr[0].keyValue;
          //   }
          //   else if(customerTcsArr.length>1)
          //   {
          //     customerTcsArr=customerTcsArr.sort((a,b)=>{ return a.sortId-b.sortId});
          //     customerPhone=customerTcsArr[0].keyValue;
          //   }
          // }
          let customerEmail="";
          let customerArrEmail=this.$objBaseInfo.customerTcs.filter(item=>item.linkType==2 && item.isDomc.indexOf(isdomc)>=0);
          if(customerArrEmail.length>0)
          {
            customerEmail=customerArrEmail[0].keyValue;
          }
          //获取入住人姓名
          let name=this.bookingForm.name;
          //所有国际订单都传拼音  sabre渠道的订单都传拼音
          // (this.bookingCreateParam.source.indexOf("sabre") > -1 || this.bookingCreateParam.source.indexOf("booking") > -1)
          if(isdomc=="I" || (this.bookingCreateParam.source && (this.bookingCreateParam.source.indexOf("sabre") > -1 || this.bookingCreateParam.source.indexOf("booking") > -1)))//所有的sabre资源传拼音
          {
            name=this.bookingForm.namePinyin;
          }
          var itineraryLanguage = this.languageValue;
          if(this.$objBaseInfo.itineraryLanguageSet){
            var data = JSON.parse(this.$objBaseInfo.itineraryLanguageSet);
            //if(data.Type == "2"){
            if(this.$objBaseInfo.destinationType == "I"){
              if(data.AreaItem.International == "1"){
                itineraryLanguage = "zh-CN";
              }else if(data.AreaItem.International == "2"){
                itineraryLanguage = "en";
              }
            }
            if(this.$objBaseInfo.destinationType == "D"){
              if(isCityGAT(this.orderCityInfo.provinceCode)){
                if(data.AreaItem.GangAoTai == "1"){
                  itineraryLanguage = "zh-CN";
                }else if(data.AreaItem.GangAoTai == "2"){
                  itineraryLanguage = "en";
                }
              }else{
                if(data.AreaItem.Domestic == "1"){
                  itineraryLanguage = "zh-CN";
                }else if(data.AreaItem.Domestic == "2"){
                  itineraryLanguage = "en";
                }
              }
            }
            //}
          }
          if(this.bookingForm.loyaltyCardType==this.$t('MANUAL.SELECTPLACEHOLDER')){
            this.bookingForm.loyaltyCardType="";
          }
            let linkInfo = null;
          if(this.showLinker){
            linkInfo = {
              name: this.bookingForm.linkerName,
              mobile: this.bookingForm.linkerMobile.includes("*") ? this.bookingForm.linkerFMobile : this.bookingForm.linkerMobile,
              email: this.bookingForm.linkerEmail,
            };
          }
          let bookParam = {
            // sabre资源,订单预检获取RateId，提供给下单接口，加速下单
            rateid: this.bookingCreateParam.rateId,
            creationTime: new Date().valueOf(),
            hotelcode: this.pageParam.hotelcode,
            hotelNames: this.hotelInfo.hotelName,
            isCPHotel: this.hotelInfo.isCp.toString() == "true" ? true : false,
            isAPHotel: this.hotelInfo.isAp.toString() == "true" ? true : false,
            roomTypeCode: this.pageParam.roomTypeId,
            roomTypeName: this.hotelInfo.roomName,
            ratePlanCode: this.bookingCreateParam.RatePlanCode,
            rateAccessCode: this.bookingCreateParam.RateAccessCode,
            ratePlanName: this.bookingCreateParam.ratePlanName,
            source: this.bookingCreateParam.source,
            reservationType: this.isGuaranteeRequired ? 0 : 1,
            paymentType: this.bookingCreateParam.paymentType,
            priceType: this.bookingCreateParam.priceType,
            priceOwner: this.bookingCreateParam.priceOwner,
            roomCount: this.pageParam.roomCount,
            costCenterid:this.bookingForm.costCenterid,//成本中心id
            roomGuests: [
            {
                name: name,
                userId: this.bookingForm.travelerCode,
                refId: this.bookingCreateParam.RefId,
                guestLevel: this.bookingCreateParam.userLevel,
                departmentCode: this.bookingCreateParam.departmentCode,
                departmentName: this.bookingCreateParam.departmentName,
                birthday: this.bookingForm.birthday,
                idCardNumber: this.bookingForm.idCardNumber,
                passportNumber: this.bookingForm.passportNumber,
                visaCountry: this.bookingForm.visaCountry,
                sex: this.bookingForm.sex,
                isEmployee: this.bookingCreateParam.isEmployee,
                contact: {
                  email: this.bookingForm.email,
                  fax: "",
                  mobile: this.bookingForm.mobile.includes("*") ? this.bookingForm.fmobile : this.bookingForm.mobile,
                  telephone: "",
                  other: "",
                  linkerInfo: linkInfo ? JSON.stringify(linkInfo) : "",
                },
                mi: {},
                email:customerEmail,
                isMajorTravelers:true,
              },
            ],
            serviceFees: {
              amount: 0,
              currencyCode: "",
              percentage: 0,
            },
            dailyPrices: this.dailyPrices,
            taxes: {
              amount: this.taxesInfo.taxAmount? this.taxesInfo.taxAmount.toString() : null,
              currencyCode: this.taxesInfo.taxCurrencyCode ? this.taxesInfo.taxCurrencyCode : null,
            },
            fees: {
              amount: this.taxesInfo.others ? this.taxesInfo.others.toString() : null,
              currencyCode: this.taxesInfo.othersCurrencyCode ? this.taxesInfo.othersCurrencyCode : null,
            },
            totalPrice: this.totalPrice,
            currencyCode: this.$objBaseInfo.defaultCurrencyCode,
            checkInDate: formatDateTime(this.pageParam.checkInAt, "YYYY-MM-DD"),
            checkOutDate: formatDateTime(this.pageParam.checkOutAt,"YYYY-MM-DD"),
            arrivalTime: this.bookingForm.latestArrivalTime,
            otherRequirement: "",
            paymentInfo: {
              paymentType: this.bookingCreateParam.paymentType,
              airplusUatp: this.bookingForm.uatpCardNo,//uatp卡卡号
              airplusUatpvalidYearMonth: this.bookingForm.uatpCardValidDate,//uatp卡有效期
              uATPSupplierAndModel : this.bookingForm.supplierAndModel,//uatp卡供应商及模式
              formOfPayment: this.bookingForm.paymentType + "",
              creditCardCompanyCode: "",
              creditCardNumber: "",
              cVV: "",
              validMonth: "",
              validYear: "",
            },
            bookingAgents: [
              {
                type: this.$objBaseInfo.hotelBookingRole.toString(),
                name: this.$objBaseInfo.userName,
                userId: this.$objBaseInfo.loginID,
                level: this.$objBaseInfo.userLevel,
                departmentCode: this.$objBaseInfo.departmentCode,
                departmentName: this.$objBaseInfo.departmentName,
                contact: {
                  email: this.$objBaseInfo.eMail,
                  fax: "",
                  mobile: this.$objBaseInfo.mobilePhone,
                  telephone: "",
                  other: "",
                },
              },
            ],
            cityCode: this.hotelInfo.city,
            hotelAddress: this.hotelInfo.address,
            hotelContact: this.hotelInfo.contactNumber,
            guaranteeType: this.bookingCreateParam.guaranteeRules,
            isOutOfPolicy: isOutOfPolicy,
            outOfPolicyReason: this.bookingCreateParam.outOfPolicyReasons,
            breakfastQty: this.bookingCreateParam.breakfastNum,
            breakfastFlag: this.bookingCreateParam.breakfastFlag,
            sabreBreakfast: this.bookingCreateParam.breakfast == null ? null : Boolean(this.bookingCreateParam.breakfast),
            loyaltyPoints: this.bookingCreateParam.isIntegral,
            cancellationRules: {
              cancellationPolicy: this.cancellationPolicy.type,
              deadlineDay: this.cancellationPolicy.deadlineDay,
              deadlineTime: this.cancellationPolicy.deadlineTime,
              amount: this.cancellationPolicy.amount,
              currencyCode: this.$objBaseInfo.defaultCurrencyCode,
              numberNights: this.cancellationPolicy.nights,
            },
            isForeignerAllowed: this.hotelInfo.isSupportForeign,
            isManualOrder: false,
            isInternational: this.$objBaseInfo.destinationType == "I" ? true : false,
            extend: [
              {
                name: "Special",
                valueInfo: specialValue,
              },
              {
                name: "negotiationPriceType",
                valueInfo: negotiationPriceType,
              },
              {
                name: "ReasonCode",
                valueInfo: exceeded,
              },
              {
                name: "bookingType",
                valueInfo: bookingType,
              },
              {
                name: "cwtMark",
                valueInfo: cwtMark,
              },
              {
                name: "beforeTaxAmountTotal",
                valueInfo: beforeTaxAmountTotal,
              },
              {
                name: "rdescription",
                valueInfo: rdescription,
              },
              {
                name: "intlTaxDisplayInfo",
                valueInfo: intlTaxDisplayInfo,
              },
              {
                name: "roomTypeDescription",
                valueInfo: roomTypeDescription,
              },
              {
                name: "countryCode",
                valueInfo: countryCode,
              },
              {
                name: "productCode",
                valueInfo: productCode,
              },

            ],
            approvedTrip: {
              systemTripNo: this.$objBaseInfo.tripOrderInfo ? this.$objBaseInfo.tripOrderInfo.triporderNo : "",
              customerTripNo: this.$objBaseInfo.tripOrderInfo ? this.$objBaseInfo.tripOrderInfo.customerOrderNo : "",
              tripPurpose: "",
            },
            posCode: this.$objBaseInfo.poscode,
            customerName: this.$objBaseInfo.customerName,
            miInfoList: miParamList,
            sessionInfo: {
              languageCode: itineraryLanguage,
              bookingChannel: this.$objBaseInfo.sourceType,
              device: this.$objBaseInfo.channelId,
            },
            star: this.hotelInfo.starRating.toString(),
            group: this.hotelInfo.group.toString(),
            latitude: this.hotelInfo.latitude,
            longitude: this.hotelInfo.longitude,
            loyaltyid: (this.loyaltyCardInfo.showLoyatyCard && this.isIntegralGroup)? this.bookingForm.loyaltyCardType:this.bookingForm.loyaltyCardTypeInput,
            isNeedCvv:this.bookingCreateParam.isNeedCvv,
            customerPhone:customerPhone,
            isRepeat:this.isRepeat,//是否重单
            breakfastDescription:this.bookingCreateParam.breakfastDescription,//早餐描述
          };
          if(this.isMultiplayerBooking)//判断是否多人出行
          {
            //获取入住人姓名
            let name=this.bookingForm.bookingFormOther.name;
            //所有国际订单都传拼音  sabre渠道的订单都传拼音
            if(isdomc=="I" || (this.bookingCreateParam.source && (this.bookingCreateParam.source.indexOf("sabre") > -1 || this.bookingCreateParam.source.indexOf("booking") > -1 )))//所有的sabre资源传拼音
            {
              if(this.bookingForm.bookingFormOther.namePinyin!="" && this.bookingForm.bookingFormOther.namePinyin!=null && this.bookingForm.bookingFormOther.namePinyin!=undefined)
              {
                name=this.bookingForm.bookingFormOther.namePinyin;
              }
            }
            let otherLinkInfo = null;
            if(this.showLinker){
              otherLinkInfo = {
                name: this.bookingForm.bookingFormOther.linkerName,
                mobile: this.bookingForm.bookingFormOther.linkerMobile.includes("*") ? this.bookingForm.bookingFormOther.linkerFMobile : this.bookingForm.bookingFormOther.linkerMobile,
                email: this.bookingForm.bookingFormOther.linkerEmail,
              };
            }
            if(this.showLinker){
              linkInfo = {
                name: this.bookingForm.linkerName,
                mobile: this.bookingForm.linkerMobile,
                email: this.bookingForm.linkerEmail,
              };
            }
            let gustInfo={
                name: name,
                userId: this.bookingForm.bookingFormOther.travelerCode,
                refId: this.bookingForm.bookingFormOther.RefId,
                guestLevel: this.bookingForm.bookingFormOther.userLevel,
                departmentCode: this.bookingForm.bookingFormOther.departmentCode,
                departmentName: this.bookingForm.bookingFormOther.departmentName,
                birthday: this.bookingForm.bookingFormOther.birthday,
                idCardNumber: this.bookingForm.bookingFormOther.idCardNumber,
                passportNumber: this.bookingForm.bookingFormOther.passportNumber,
                visaCountry: this.bookingForm.bookingFormOther.visaCountry,
                sex: this.bookingForm.bookingFormOther.sex,
                isEmployee: this.bookingForm.bookingFormOther.isEmployee,
                contact: {
                  email: this.bookingForm.bookingFormOther.email,
                  fax: "",
                  mobile:this.bookingForm.bookingFormOther.mobile.includes("*") ? this.bookingForm.bookingFormOther.fmobile : this.bookingForm.bookingFormOther.mobile,
                  telephone: "",
                  other: "",
                  linkerInfo: otherLinkInfo ? JSON.stringify(otherLinkInfo) : "",
                },
                email:customerEmail,
                isMajorTravelers:false,
            }
            if(gustInfo.refId==bookParam.roomGuests[0].refId && gustInfo.name==bookParam.roomGuests[0].name)
            {
              this.confirmFlag = true;
              this.confirmMsg =this.$t("BOOKING.OTHERTITLEREPORT");;
              this.submitLoading = false;
              return;
            }
            bookParam.roomGuests.push(gustInfo);
          }
          if (this.orderCityInfo && this.orderCityInfo != {}) {
            bookParam.cityName = this.orderCityInfo.cityNameLists;
            bookParam.country = this.orderCityInfo.countryNameLists;
            bookParam.province = this.orderCityInfo.provinceNameLists;
            bookParam.tCCode = this.orderCityInfo.tcCode;
          } else {
            console.log("城市信息获取失败");
          }
          if (sessionStorage.getItem(this.$objBaseInfo.sourceType + "LastOrderNo")) {
            bookParam.lastOrderNo = sessionStorage.getItem(this.$objBaseInfo.sourceType + "LastOrderNo");
          }
          if (this.$objBaseInfo.sourceType == "OBT") {
            if (sessionStorage.getItem("OBTItineraryOrder")) {
              bookParam.itineraryOrder = sessionStorage.getItem("OBTItineraryOrder");
            }
          }
          //担保页面传参参数
          let guaranteeParam = {
            hotelName: this.hotelInfo.hotelName,
            checkInAt: formatDateTime(this.pageParam.checkInAt, "YYYY-MM-DD"),
            checkOutAt: formatDateTime(this.pageParam.checkOutAt, "YYYY-MM-DD"),
            nights:
              (new Date(this.pageParam.checkOutAt) -
                new Date(this.pageParam.checkInAt)) /
              (24 * 60 * 60 * 1000), // 几晚
            breakfastQty: this.bookingCreateParam.breakfastNum, // 早餐数量, 0：不含早， 99：含早，不指定具体份数， 1-99： 指定早餐具体份数
            roomCount: this.pageParam.roomCount, //房间数
            totalPrice: this.totalPrice, //总价
            floor: this.hotelInfo.floor, //房间楼层
            area: this.hotelInfo.area, //area
            window: this.hotelInfo.hasWindow, //window
            wifi: this.hotelInfo.wifi, //wifi
            roomName: this.hotelInfo.roomName,
            bookParam: bookParam,
            supportedCreditCards: this.bookingCreateParam.supportedCreditCards,
            isGuaranteeType:this.isGuaranteeType
          };
          //非公付 以及担保 跳转担保页面
          if (
            (this.bookingCreateParam.paymentType.toString() == "1" &&
            this.isGuaranteeRequired &&
            this.bookingCreateParam.source !='elong')
            ||(!this.isGuaranteeRequired && this.isGuaranteeType && this.bookingCreateParam.source.indexOf("sabre") > -1 
            && this.bookingCreateParam.paymentType==1)
          ) {
            sessionStorage.setItem(
              "createGuarantee",
              JSON.stringify(guaranteeParam)
            );
            this.submitLoading = false;
            this.$router.push({
              name: "Guarantee",
              query: { sourceType: this.$objBaseInfo.sourceType },
            });
          }
          else {
            //调用创建订单的接口
            createBooking(bookParam)
              .then((res) => {
                this.submitLoading = false;
                if (res.code === 200) {
                  if (res.data.error.code == 10809) {
                    this.toConfirmation(res.data.bookingId);
                  } else if (codeIsCode(res.data.error.code)) {
                    //预定失败 需要跳转
                    this.orderIdTo = res.data.bookingId;
                    if(res.data.error.isMapping==true)
                    {
                      let message="";
                      if(this.$i18n.locale == "en")
                      {
                        message=res.data.error.enMessage;
                      }
                      else
                      {
                        message=res.data.error.message;
                      }
                      this.confirmMsg =message;
                      this.confirmFlag = true;
                    }
                    else
                    {
                      this.confirmMsg =
                        this.$t("ERRORMESSAGE.BOOKINGFAILED") +
                        (this.$t("ERRORMESSAGE." + res.data.error.code) ===
                        "ERRORMESSAGE." + res.data.error.code
                          ? this.$t("ERRORMESSAGE.NOTFOUND")
                          : this.$t("ERRORMESSAGE." + res.data.error.code));
                      this.confirmFlag = true;
                      console.log(
                        "创建订单失败, code:" + res.data.error.code,
                        res.data.error.message
                      );
                    }
                  } else if (res.data.error.code != 0) {
                    //预定失败 需要跳转
                    this.orderIdTo = res.data.bookingId;
                    if(res.data.error.isMapping==true)
                    {
                      let message="";
                      if(this.$i18n.locale == "en")
                      {
                        message=res.data.error.enMessage;
                      }
                      else
                      {
                        message=res.data.error.message;
                      }
                      this.confirmMsg =message;
                      this.confirmFlag = true;
                    }
                    else
                    {
                      this.confirmFlag = true;
                      this.confirmMsg =
                        this.$t("ERRORMESSAGE." + res.data.error.code) ===
                        "ERRORMESSAGE." + res.data.error.code
                          ? this.$t("ERRORMESSAGE.NOTFOUND")
                          : this.$t("ERRORMESSAGE." + res.data.error.code);
                      console.log(
                        "创建订单失败, code:" + res.data.error.code,
                        res.data.error.message
                      );
                    }
                  } else {
                    this.toConfirmation(res.data.bookingId);
                  }
                }
                else if (res.code === 500) {
                  this.confirmFlag = true;
                  if(res.message=="ORDER501")
                  {
                    this.confirmMsg = this.$t("ERRORMESSAGE.ORDER501");
                  }
                  else
                  {
                    this.confirmMsg = this.$t("ERRORMESSAGE.ORDER500");
                  }
                }
                else {
                  //预定失败 需要跳转
                  this.orderIdTo = res.data.bookingId;
                  if(res.data.error.isMapping==true)
                  {
                    let message="";
                    if(this.$i18n.locale == "en")
                    {
                      message=res.data.error.enMessage;
                    }
                    else
                    {
                      message=res.data.error.message;
                    }
                    this.confirmMsg =message;
                    this.confirmFlag = true;
                  }
                  else
                  {
                    this.confirmFlag = true;
                    this.confirmMsg =
                    this.$t("ERRORMESSAGE." + res.code) ===
                        "ERRORMESSAGE." + res.code
                          ? this.$t("ERRORMESSAGE.NOTFOUND")
                          : this.$t("ERRORMESSAGE." + res.code);
                      console.log("创建订单失败,code:" + res.code, res.message);
                  }
                }
              })
              .catch((err) => {
                this.submitLoading = false;
                this.confirmFlag = true;
                this.confirmMsg = this.$t("ERRORMESSAGE.40001");
                console.log("创建订单异常:", err.objError);
              });
          }
        } else {
          this.submitLoading = false;
          return false;
        }
      });
    },
    toConfirmation(orderId) {
      if(orderId!=null && orderId!=undefined && orderId!="")
      {
        sessionStorage.removeItem("createOrder");
        sessionStorage.removeItem(this.$objBaseInfo.sourceType + "LastOrderNo");
        sessionStorage.removeItem("OBTItineraryOrder");
        this.$router.push({
          name: "Confirmation",
          query: { orderId: orderId, sourceType: this.$objBaseInfo.sourceType },
        });
      }

    },
    // 弹出人员姓名窗口方法
    showNamePop(val) {
      if(val=="bookingForm") //判断是否主要出行人
      {
        this.isMajorTravelers=true;
      }
      else
      {
        this.isMajorTravelers=false;
      }
      if (this.$objBaseInfo.channelId == "WEB") {
        if (
          this.$objBaseInfo.ordApprovalType == 1 &&
          this.$objBaseInfo.tripOrderInfo != null &&
          this.$objBaseInfo.tripOrderInfo != undefined
        ) {
          //开启行前审批的出行人信息
          this.dialogTraveler = true;
        } else {
          this.dialogUserName = true;
        }
      } else {
        if (
          this.$objBaseInfo.ordApprovalType == 1 &&
          this.$objBaseInfo.tripOrderInfo != null &&
          this.$objBaseInfo.tripOrderInfo != undefined
        ) {
          //开启行前审批的出行人信息
          this.mobileTravelShow = true;
        } else {
          this.mobileNameShow = true;
        }
      }
      console.log("弹出人员姓名窗口方法",this.dialogUserName );
    },
    // 当前选中的tab
    choseeTab(tab) {
      const tabName = tab && typeof tab === "object" ? (tab.paneName || (tab.props && tab.props.name)) : tab;
      if (!tabName) {
        return;
      }
      if (this.choseeTabName != tabName) {
        this.searchName = "";
        this.searchTel = "";
        this.choseeTabName = tabName;
        if (tabName === "first") {
          this.isGuestBtn = false;
          this.getTraveler(1);
        } else {
          this.isGuestBtn = true;
          this.getTravelerTemp(1);
        }
      }
    },
    // mobile 切换tab
    choseeMobileTab(tab) {
      const tabName = tab && typeof tab === "object" ? tab.name : tab;
      if (!tabName) {
        return;
      }
      if (this.choseeTabName != tabName) {
        this.searchName = "";
        this.searchTel = "";
        this.choseeTabName = tabName;
        this.vantcurrPage = 1;
        if (tabName === "first") {
          this.getTraveler(this.vantcurrPage);
        } else {
          this.getTravelerTemp(this.vantcurrPage);
        }
      }
    },
    // mobile loading
    execLoading(val) {
      if (this.$objBaseInfo.channelId == "WEB") {
        this.clientLoading = val;
      } else {
        this.submitLoading = val;
      }
    },
    //判断是否重复预定
    verifyRepeatOrder(){
        this.submitLoading = true;
        this.isRepeat=false;
        this.$refs["bookingForm"].validate((valid) => {
        if (valid) {
          let params ={
              loginid: this.bookingCreateParam.isEmployee?this.bookingForm.travelerCode:this.bookingCreateParam.RefId,
              CheckInDate: formatDateTime(this.pageParam.checkInAt, "YYYY-MM-DD"),
              CheckOutDate: formatDateTime(this.pageParam.checkOutAt, "YYYY-MM-DD"),
              isEmployee: this.bookingCreateParam.isEmployee,
          }
          verifyRepeatOrder(params)
          .then((res) => {
            if (res.code === 200) {
              let flag_Translation=false;
              //判断是否需要走翻译接口
              if(this.$objBaseInfo.destinationType=="I" || (this.bookingCreateParam.source && (this.bookingCreateParam.source.indexOf("sabre") > -1 || this.bookingCreateParam.source.indexOf("booking") > -1)))//所有的sabre资源传拼音
              {
                flag_Translation=true;
              }
              if(flag_Translation && !isEnglishAndOtherTwo(this.bookingForm.name) && (this.bookingForm.namePinyin==undefined || this.bookingForm.namePinyin==null || this.bookingForm.namePinyin==""))
              {
                this.Pinyin(this.bookingForm.name,(result)=> {
                  this.bookingForm.namePinyin=result;
                  if (!res.data) {
                    this.submitBooking();
                  } 
                  else 
                  {
                    this.submitLoading = false;
                    this.verifyRepeatOrderFlag=true;
                  }
                });
              }
              else
              {
                if(isEnglishAndOtherTwo(this.bookingForm.name) &&(this.bookingForm.namePinyin==undefined || this.bookingForm.namePinyin==null || this.bookingForm.namePinyin==""))
                {
                  this.bookingForm.namePinyin=this.bookingForm.name;
                }
                if (!res.data) {
                  this.submitBooking();
                } 
                else 
                {
                    this.submitLoading = false;
                    this.verifyRepeatOrderFlag=true;
                }
              }

            } else {
              this.submitLoading = false;
              this.confirmFlag = true;
              this.confirmMsg =
                this.$t("ERRORMESSAGE." + res.code) === "ERRORMESSAGE." + res.code
                  ? this.$t("ERRORMESSAGE.NOTFOUND")
                  : this.$t("ERRORMESSAGE." + res.code);
              console.log("验证重复订单错误, code:" + res.code, res.message);
            }
          })
          .catch((err) => { 
            this.submitLoading = false;
            console.log(err)
          });
        } else {
          this.submitLoading = false;
          return false;
        }
      });     
    },
    //重复订单弹框-取消
    CancelRepeatOrderConfirm()
    {
      this.verifyRepeatOrderFlag=false;
    },
    //重复订单弹框-继续
    continueRepeatOrderConfirm()
    {
      this.isRepeat=true;
      this.verifyRepeatOrderFlag=false;
      this.submitLoading = true;
      this.submitBooking();
    },
    loadMore(val){
      // val是默认初始展示的条数会在渲染的时候就可以获取,具体可以打log查看
      // elementui下拉超过7条才会出滚动条,如果初始不出滚动条无法触发loadMore方法
      return () => (this.rangeNumber += 50); // 每次滚动到底部可以新增条数  可自定义
    },
    CostCenterloadMore(val){
      // val是默认初始展示的条数会在渲染的时候就可以获取,具体可以打log查看
      // elementui下拉超过7条才会出滚动条,如果初始不出滚动条无法触发loadMore方法
      if(this.costCenterrangeNumber>this.CostCenterList.length)
      {
        return;
      }
      return () => (this.costCenterrangeNumber += 50); // 每次滚动到底部可以新增条数  可自定义
    },
     // 筛选方法
    filterMethod:_debounce(function(filterVal){
      if(filterVal){
        let filterArr = this.CostCenterList.filter((item)=>{
          return item.costName.includes(filterVal)
        })
        this.costCenteroptions = filterArr;
      }else{
        this.costCenteroptions = this.CostCenterList;
      }
    },500),
    // 下拉框出现时，调用过滤方法
    visibleChange(flag){
      if(flag){
        this.filterMethod()
      }
    },
    getLoyaltyCard(){
      let LoyaltyCardParam = {
        params: {
          loginid: this.bookingForm.travelerCode,
          customerCode: this.$objBaseInfo.customerCode,
          groupcode: this.bookingCreateParam.groupId == 0 ? "" : this.bookingCreateParam.groupId,
        },
      };
      this.loyaltyCardInfo.loyaltyCardOptions= [];
      this.isAdd = true;
      this.bookingForm.loyaltyCardType = '';
      getLoyaltyCardInfo(LoyaltyCardParam)
      .then((res) => {
        if (res.code === 200) {
          if(res.data.length > 0){
            if(this.bookingCreateParam.groupId==res.data[0].remoteSystemGroupCode)
            {
              this.bookingForm.loyaltyCardType = res.data[0].memberCardNo;
            }
            for (const iterator of res.data) {
              this.loyaltyCardInfo.loyaltyCardOptions.push({
                key: iterator.pkid,
                label: iterator.memberCardNo,
                value: iterator.memberCardNo,
                groupEnName: iterator.groupEnName,
                groupName: iterator.groupName,
              });
            }
            this.isAdd = false;
            this.loyaltyCardOptionChange(this.bookingForm.loyaltyCardType);
          }
        }
      })
      .catch((err) => { 
      });
    },
    addLoyaltyCard(){
      this.$refs["addGuestInfo"].validate((valid) => {
          if (valid) {
            let parm = {
              userCode: this.$objBaseInfo.customerCode,
              userId: this.bookingCreateParam.RefId,
              groupName: this.selectGroupInfo.value,
              memberCardNo: this.loyaltyCardInfo.addLoyaltyCardInfo.cardNum,
              createBy: this.$objBaseInfo.loginID,
              lastEditBy: this.$objBaseInfo.loginID,
              groupCode: this.selectGroupInfo.key,
            };
            if(this.isAdd){
              addLoyaltyCard(parm)
              .then((res) => {
                if (res > 0) {
                  this.getLoyaltyCard();
                  this.loyaltyCardInfo.dialogAddLoyaltyCard = false;
                }
              })
              .catch((err) => { 
              });
            }else{
              parm.pkid = this.loyaltyCardPkid;
              editLoyaltyCard(parm)
              .then((res) => {
                if (res > 0) {
                  this.getLoyaltyCard();
                  this.loyaltyCardInfo.dialogAddLoyaltyCard = false;
                }
              })
              .catch((err) => { 
              });
            }
          }
        });

    },
    showAddLoyatyCard(){
      if(!this.isAdd && this.bookingForm.loyaltyCardType == ''){
        this.confirmFlag = true;
        this.confirmMsg =this.$t('BOOKING.CHOSEMEMBERSHIPCARD');
      }else{
        if(!this.isAdd){
          this.loyaltyCardInfo.addLoyaltyCardInfo.cardNum = this.bookingForm.loyaltyCardType;
        }
        this.loyaltyCardInfo.dialogAddLoyaltyCard = true;
      }
    },
    //加载超标信息
    async LoadRC()
    {
      this.submitLoading = true;
      this.bookingForm.POSRCTextValue="";
      if(this.$objBaseInfo.hasOwnProperty("posrc"))
      {
        let posrc=this.$objBaseInfo.posrc;
        this.isShowPOSRC=true;
        let text=[];
        let that=this;
        //type=1 代表自定义
        if(posrc==undefined || posrc==null)
        {
          this.isShowPOSRC=false;
          this.submitLoading = false;
          return;
        }
        if(posrc.type==undefined || posrc.type==null)
        {
          this.isShowPOSRC=false;
          this.submitLoading = false;
          return;
        }
        const arrText=posrc.text.split(',');
        if(posrc.type==1)
        {
          let price=posrc.price;//超标价格
          let ArrPrice=this.bookingCreateParam.dailyPrices;//价格间夜列表
          let PriceCurrencyCode=posrc.currencyCode;//设置价格货币类型
          let HotelPriceCurrencyCode=this.bookingCreateParam.dailyPrices[0].CurrencyCode;//酒店价格货币类型

          let ExchangeRate=1;//超标转换汇率
          let HotelPriceExchangeRate=1;//价格转变汇率
          if(PriceCurrencyCode!=HotelPriceCurrencyCode)
          {
            if(PriceCurrencyCode!="CNY")
            {
                let Param = {
                  params: {
                    fromCurrency: PriceCurrencyCode
                  },
                };
                await getExchangerate(Param).then((res) => {
                  if(res.code==200)
                  {
                      let data=res.data;
                      if(data.items.length>1)
                      {
                        let arrExchangerate=data.items.filter(function(item){
                          return item.toCurrencyCode.toUpperCase()==="CNY";
                        });
                        if(arrExchangerate.length>0)
                        {
                          ExchangeRate=arrExchangerate[0].ask;
                        }
                      }
                  }
                  console.log(res)
                })
                .catch(function (error) {
                  that.submitLoading = false;
                  console.log("转换货币汇率 请求失败", error);
                });
            }
            if(HotelPriceCurrencyCode!="CNY")
            {
                let Param = {
                  params: {
                    fromCurrency: HotelPriceCurrencyCode
                  },
                };
                await getExchangerate(Param).then((res) => {
                  if(res.code==200)
                  {
                      let data=res.data;
                      if(data.items.length>1)
                      {
                        let arrExchangerate=data.items.filter(function(item){
                          return item.toCurrencyCode.toUpperCase()==="CNY";
                        });
                        if(arrExchangerate.length>0)
                        {
                          HotelPriceExchangeRate=arrExchangerate[0].ask;
                        }
                      }
                  }
                  console.log(res)
                })
                .catch(function (error) {
                  that.submitLoading = false;
                  console.log("转换货币汇率 请求失败", error);
                });
            }
          }
          let result=[];
          switch(posrc.symbol) {
                case 1:
                  result=ArrPrice.filter(function(item,index,array){
                    return (item.Price*HotelPriceExchangeRate)>(price*ExchangeRate);
                  });
                  break;
                case 2:
                  result=ArrPrice.filter(function(item,index,array){
                    return (item.Price*HotelPriceExchangeRate)>=(price*ExchangeRate);
                  });
                  break;
                case 3:
                  result=ArrPrice.filter(function(item,index,array){
                    return (item.Price*HotelPriceExchangeRate)<(price*ExchangeRate);
                  });
                    break;
                case 4:
                  result=ArrPrice.filter(function(item,index,array){
                    return (item.Price*HotelPriceExchangeRate)<=(price*ExchangeRate);
                  });
                  break;
            }
            let compliance=[];
            //违规
            if(result.length>0)
            {
              if(posrc.noCompliance==undefined || posrc.noCompliance==null || posrc.noCompliance=="")
              {
                this.isShowPOSRC=false;
                this.submitLoading = false;
                return;
              }
              let arrCode=posrc.noCompliance.split(',');
              compliance = arrText.filter(function (val) { return (arrCode.indexOf(val.split('-')[0]) > -1) })
              this.bookingForm.isExceeded=true;
            }
            else
            {
              if(posrc.compliance==undefined || posrc.compliance==null || posrc.compliance=="")
              {
                this.isShowPOSRC=false;
                this.submitLoading = false;
                return;
              }
              let arrCode=posrc.compliance.split(',');
              compliance = arrText.filter(function (val) { return (arrCode.indexOf(val.split('-')[0]) > -1) })
              this.bookingForm.isExceeded=false;
            }
            for (let value of compliance) {
              let arr=value.split('-');
              text.push({code:arr[0],cnText:arr[1],enText:arr[2]});
            }
            this.POSRCTextList=text;
            if(text.length==1)
            {
              this.bookingForm.POSRCTextValue=text[0].code;
            }
        }
        else
        {
            let isOutOfPolicy = null;
            if(this.bookingCreateParam.hasOwnProperty("isOutOfPolicy")){
              if(this.bookingCreateParam.isOutOfPolicy!=undefined && this.bookingCreateParam.isOutOfPolicy!=null && this.bookingCreateParam.isOutOfPolicy!="")
              {
                isOutOfPolicy = this.bookingCreateParam.isOutOfPolicy.toString() == "true"? true: false;
              } 
            }
            if(isOutOfPolicy!=null)
            {
              let compliance=[];
              //违规
              if(isOutOfPolicy)
              {
                if(posrc.noCompliance==undefined || posrc.noCompliance==null || posrc.noCompliance=="")
                {
                  this.isShowPOSRC=false;
                  this.submitLoading = false;
                  return;
                }
                let arrCode=posrc.noCompliance.split(',');
                compliance = arrText.filter(function (val) { return (arrCode.indexOf(val.split('-')[0]) > -1) })
                this.bookingForm.isExceeded=true;
              }
              else
              {
                if(posrc.compliance==undefined || posrc.compliance==null || posrc.compliance=="")
                {
                  this.isShowPOSRC=false;
                  this.submitLoading = false;
                  return;
                }
                let arrCode=posrc.compliance.split(',');
                compliance = arrText.filter(function (val) { return (arrCode.indexOf(val.split('-')[0]) > -1) })
                this.bookingForm.isExceeded=false;
              }
              for (let value of compliance) {
                let arr=value.split('-');
                text.push({code:arr[0],cnText:arr[1],enText:arr[2]});
              }
              this.POSRCTextList=text;
              if(text.length==1)
              {
                this.bookingForm.POSRCTextValue=text[0].code;
              }
            }
            else//type=2时代表使用是否超标 没有超标信息代表没有违规 按合规展示
            {
              this.isShowPOSRC=true;
              let compliance=[];
              //违规
              if(isOutOfPolicy)
              {
                if(posrc.noCompliance==undefined || posrc.noCompliance==null || posrc.noCompliance=="")
                {
                  this.isShowPOSRC=false;
                  this.submitLoading = false;
                  return;
                }
                let arrCode=posrc.noCompliance.split(',');
                compliance = arrText.filter(function (val) { return (arrCode.indexOf(val.split('-')[0]) > -1) })
                this.bookingForm.isExceeded=true;
              }
              else
              {
                if(posrc.compliance==undefined || posrc.compliance==null || posrc.compliance=="")
                {
                  this.isShowPOSRC=false;
                  this.submitLoading = false;
                  return;
                }
                let arrCode=posrc.compliance.split(',');
                compliance = arrText.filter(function (val) { return (arrCode.indexOf(val.split('-')[0]) > -1) })
                this.bookingForm.isExceeded=false;
              }
              for (let value of compliance) {
                let arr=value.split('-');
                text.push({code:arr[0],cnText:arr[1],enText:arr[2]});
              }
              this.POSRCTextList=text;
              if(text.length==1)
              {
                this.bookingForm.POSRCTextValue=text[0].code;
              }
            }
        }
      }
      else
      {
        this.isShowPOSRC=false;
      }
      this.submitLoading = false;
    },
    clearCNCarNum(type){

      switch(type)
      {
        case 1:
          this.loyaltyCardInfo.addLoyaltyCardInfo.cardNum = this.loyaltyCardInfo.addLoyaltyCardInfo.cardNum.replace(/[^\x00-\xff]/g, "");  //清除中文
          break;
        case 2:
          this.bookingForm.loyaltyCardTypeInput = this.bookingForm.loyaltyCardTypeInput.replace(/[^\x00-\xff]/g, "");  //清除中文
          break;
      }
      
    },
    MobileMINoteLink(item)
    {
      let link="";
      if(this.$i18n.locale == "en")
      {
        if(item.noteENLink!=undefined && item.noteENLink!=null)
        {
          link=item.noteENLink;
        }
      }
      else
      {
        if(item.noteCNLink!=undefined && item.noteCNLink!=null)
        {
          link=item.noteENLink;
        }
      }
      if(link!="")
      {
        window.open(link,"");
      }
    },
    loyaltyCardChange(item){
      this.selectGroupInfo = item;
    },
    handleFocus(isSign){
      const rulesMap = {
        1: { rules: this.mobileRules, field: 'mobile', form: this.bookingForm },
        2: { rules: this.otherMobileRules, field: 'mobile', form: this.bookingForm.bookingFormOther },
        3: { rules: this.linkerMobileRules, field: 'linkerMobile', form: this.bookingForm },
        4: { rules: this.otherLinkerMobileRules, field: 'linkerMobile', form: this.bookingForm.bookingFormOther },
      };

      const rule = rulesMap[isSign];
      if (rule) {
        if (rule.rules.length === 1) {
          rule.rules.push({
            pattern: /^1[3456789]\d{9}$/,
            message: this.$t('BOOKING.PHONEVA'),
            trigger: ['blur'],
              });
        }
        rule.form[rule.field] = rule.form[rule.field].includes("*") ? "" : rule.form[rule.field];
      }
    },
     //获取港澳台consul配置
    async getCityConcelValue() {
      let Params = {
        params: {
          key: "CityCodes",
        },
      };
      await getConsul(Params)
        .then((res) => {
          if (res.code == 200) {
            this.CityCodes=res.message.split(',');
          }
        })
        .catch(function (error) {
          console.log("请求失败", error.objError);
        });
    },
    Pinyin(name,callback) {
      let Params = {
        params: {
          value: name,
        },
      };
      toPinyin(Params)
        .then((res) => {
          if (res.code == 200) {
            callback(res.message);
          }
        })
        .catch(function (error) {
          callback(name);
        });
    },
    //加载成本中心
    LoadCostCenter()
    {
      //判断是否存在成本中心配置
      console.log(this.$objBaseInfo);
      if(Object.prototype.hasOwnProperty.call(this.$objBaseInfo,"posCostCenterModel"))
      {
        let posCostCenterModel=this.$objBaseInfo.posCostCenterModel;
        if(posCostCenterModel==undefined || posCostCenterModel==null || posCostCenterModel=="")
        {
          return;
        }
        this.costCenterType=posCostCenterModel.selectedtype;
        if(posCostCenterModel.isopen==1)//是否开启成本中心
        {
          if(posCostCenterModel.isreq==1)
          {
            this.isCostCenterOpen=true;//打开成本中心--成本中心必填
          }
          this.GetCostCenterList();//获取成本中心列表
          if(posCostCenterModel.isview==1)
          {
            //展示成本中心
            this.isCostCenterShow=true;
          }
          else
          {
            //不展示成本中心
            this.isCostCenterShow=false;
          }
          if(posCostCenterModel.isuatp==1)
          {
            this.isValidUATP=true;
            this.isValidExpiredUATP=false;
          }
          else
          {
            this.isValidUATP=false;
          }
        }
        else
        {
          //代表关闭
          this.isCostCenterOpen=false;
          //不显示成本中心
          this.isCostCenterShow=false;
        }
        console.log(this.$objBaseInfo.posCostCenterModel);
      }
    },
    //获取UATP卡详情
    GetUATPDetails() {
      if(this.$objBaseInfo.destinationType.indexOf("I")>-1)
      {
        if(this.$objBaseInfo.posCostCenterModel.isOpenJICTA)
        {
          this.isopenCTA=true;
          return;
        }
      }
      else
      {
        if(this.CityCodes.indexOf(this.hotelInfo.city)>=0)
        {
          if(this.$objBaseInfo.posCostCenterModel.isOpenGATCTA)
          {
            this.isopenCTA=true;
            return;
          }
        }
        else if(this.$objBaseInfo.posCostCenterModel.isOpenJDCTA)
        {
          this.isopenCTA=true;
          return;
        }
      }
      let Params = {
        params: {
          cradNo: this.bookingForm.uatpCardNo,
          userCode:this.$objBaseInfo.customerCode,
        },
      };
      let that=this;
      getuatp(Params)
        .then((res) => {
          if (res.code == 200) {
            let date=that.toValidate(res.data.expirationDate);
            let monthStartDate =new Date(new Date().getFullYear(), new Date().getMonth(),1);
            if (new Date(date) < monthStartDate) {
              if(that.isValidUATP)
              {
                that.confirmFlag = true;
                that.confirmMsg =that.$t("BOOKING.CostCenterUATPTitle2");
                that.isValidExpiredUATP=false;
              }
              else
              {
                that.bookingForm.uatpCardValidDate=res.data.expirationDate;
                that.bookingForm.supplierAndModel=res.data.supplierAndModel;
              }
            }
            else
            {
              that.bookingForm.uatpCardValidDate=res.data.expirationDate;
              that.bookingForm.supplierAndModel=res.data.supplierAndModel;
              that.isValidExpiredUATP=true;
            }
          }
          else
          {
            if(that.isValidUATP){
              that.confirmFlag = true;
              that.confirmMsg =this.$t("BOOKING.CostCenterUATPTitle1");
            }
          }
        })
        .catch(function (error) {
            console.log(error);
        });
    },
    //成本中心下拉改变事件
    CostCenterChange(val) {
      this.bookingForm.uatpCardValidDate="";
      this.bookingForm.supplierAndModel="";
      this.bookingForm.costCenterid=0;
      this.bookingForm.uatpCardNo="";
      let arr=this.CostCenterList.filter(p=>p.id==val);
      if(arr.length>0)
      {
        let item=arr[0];
        if(Object.prototype.hasOwnProperty.call(this.$objBaseInfo,"posCostCenterModel"))
        {
          let posCostCenterModel=this.$objBaseInfo.posCostCenterModel;
          this.bookingForm.costCenterid=item.id;
          this.bookingForm.uatpCardNo=item.uatpno;
          if(posCostCenterModel.isuatp==1)
          {
            if(this.bookingForm.uatpCardNo=="")
            {
              this.confirmFlag = true;
              this.confirmMsg =this.$t("BOOKING.CostCenterUATPTitle1");
            }
            else
            {
              this.GetUATPDetails();
            }
          }
          else
          {
            if(this.bookingForm.uatpCardNo!="")
            {
              this.GetUATPDetails();
            }
          }
        }
      }
    },
       //信用卡有效期转换
    toValidate(validate) {
      if (validate) {
        //当年年份前两个字符
        const yyF = new Date().getFullYear().toString().substr(0, 2);
        if (validate.toString().length == 4) {
          //时间格式 MMYY
          const yyyyF = yyF + validate.toString().substr(2, 2);
          const mmF = validate.toString().substr(0, 2);
          return yyyyF + "-" + mmF + "-" + "01";
        } else if (
          validate.toString().length == 5 &&
          validate.toString().indexOf("/") > -1
        ) {
          //时间格式 MM/YY
          const dateArr = validate.split("/");
          return yyF + dateArr[1] + "-" + dateArr[0] + "-" + "01";
        } else if (
          //时间格式 yyyy-MM-ddThh:mm:ss.000Z
          validate.toString().indexOf("T") > -1
        ) {
          let shortDate = validate.toString().substr(0, 10);
          return shortDate;
        } else {
          console.log("信用卡有效期：", validate);
        }
      } else {
        console.log("信用卡有效期：", validate);
        return validate;
      }
    },
    //获取成本中心list
    GetCostCenterList() {
      if(this.bookingForm.travelerCode=="" ||this.bookingForm.travelerCode==undefined || this.bookingForm.travelerCode==null)
      {
        return;
      }
      let Params = {
        params: {
          customerCode: this.$objBaseInfo.customerCode,
          agentId: this.$objBaseInfo.loginID,
          gustId: this.bookingForm.travelerCode,
          type: this.costCenterType,
        },
      };
      let that=this;
      this.CostCenterList=[];
      this.bookingForm.costCenterid=0;
      this.bookingForm.uatpCardNo="";
      this.bookingForm.uatpCardValidDate="";
      this.bookingForm.supplierAndModel="";
      getCostCenter(Params)
        .then((res) => {
          if (res.code == 200) {
            let arr=res.data;
            that.CostCenterList=arr;
            if(Object.prototype.hasOwnProperty.call(that.$objBaseInfo,"posCostCenterModel"))
            {
              let posCostCenterModel=that.$objBaseInfo.posCostCenterModel;
              if(posCostCenterModel.isopen==0)
              {
                return;//代表关闭成本中心
              }
              if(posCostCenterModel.isselect==0)//代表默认选中 不可更改
              {
                that.isCostCenterEdit=true;
              }
              else
              {
                //可以更改
                that.isCostCenterEdit=false;
              }
              if(arr.length>0)
              {
                that.costCenteroptions = that.CostCenterList.slice(0,1);
                that.bookingForm.costCenterid=arr[0].id;
                that.bookingForm.uatpCardNo=arr[0].uatpno;
              }
              else//判断是否存在有可供选择的成本中心
              {
                that.confirmFlag = true;
                that.confirmMsg =that.$t("BOOKING.CostCenterTitle2");
                return;
              }
              if(posCostCenterModel.isuatp==1)
              {
                if(that.bookingForm.uatpCardNo=="")
                {
                  that.confirmFlag = true;
                  that.confirmMsg =that.$t("BOOKING.CostCenterUATPTitle1");
                }
                else
                {
                  that.GetUATPDetails();//调用获取成本中心有效期方法
                }
              }
              else
              {
                if(that.bookingForm.uatpCardNo!="")
                {
                  that.GetUATPDetails();//调用获取成本中心有效期方法
                }
              }
            }
          }
          else
          {
            that.confirmFlag = true;
            that.confirmMsg =that.$t("BOOKING.CostCenterTitle2");
          }
        })
        .catch(function (error) {
          that.confirmFlag = true;
          that.confirmMsg =that.$t("BOOKING.CostCenterTitle2");
        });
    },
    LatestArrivalTimeChange(value)
    {
      this.isGuaranteeType=false;
      let arr=value.split(":");
      //GDS 资源（sabre）才判断前端现付的非担保订单 弹框
      if(arr.length>0 && !this.isGuaranteeRequired && this.bookingCreateParam.source.indexOf("sabre") > -1 && this.bookingCreateParam.paymentType==1)
      {
        if(this.bookingCreateParam.source.indexOf("sabre-oversea") > -1)
        {
          this.isGuaranteeType = true;
        }
        else
        {
          let hours = parseInt(arr[0]);
          if (hours >= 18 || hours == 0) {
            this.isGuaranteeType = true;
          }
          else {
            this.isGuaranteeType = false;
            this.confirmFlag = true;
            this.confirmMsg = this.$t("BOOKING.SPECIALALERT2");
          }
        }
        
      }
    },
    checkIsShowLoyatyCard(){
      let Params = {
        params: {
          groupCode: this.bookingCreateParam.groupId == 0 ? "" : this.bookingCreateParam.groupId,
        },
      };
      getHotelgroupInfo(Params)
      .then((res) => {
        if (res.code === 200) {
          if(res.data.length > 0)
          {
            this.loyaltyCardInfo.hotelgroupsInfo = [];
            this.loyaltyCardInfo.hotelgroupName = this.$i18n.locale == "en" ? res.data[0].groupNameEn : res.data[0].groupNameCn;
            for (const iterator of res.data) {
              //this.isIntegralGroup = iterator.isIntegral;
              this.loyaltyCardInfo.hotelgroupsInfo.push({
                key: iterator.groupCode,
                value: this.$i18n.locale == "en" ? iterator.groupNameEn : iterator.groupNameCn,
              });
            }
            this.selectGroupInfo = this.loyaltyCardInfo.hotelgroupsInfo[0];
          }
        }
      })
      .catch((err) => { 
      });
    },
    loyaltyCardOptionChange(value){
      const selectedOption = this.loyaltyCardInfo.loyaltyCardOptions.find(option => option.value === value);
      if (selectedOption) {
        this.loyaltyCardPkid = selectedOption.key;
      }
    },
    //获取搜索下拉值-国省市
    async getCountryList(countryCode) {
      let searchparams = {
        params: {
          countryCode: countryCode,
        },
      };
      await getcountryList(searchparams)
        .then((res) => {
          if(res.code==200 && res.data.list.length > 0){
            this.intlTaxDisplay = res.data.list[0].intlTaxDisplay;
          }
        });
    },
    openCardTypeDialog(){
      this.selectedCardType = this.bookingForm.cardType;
      this.dialogValue = true;
    },
    openOtherCardTypeDialog(){
      this.selectedOtherCardType = this.bookingForm.bookingFormOther.cardType;
      this.dialogOtherValue = true;
    },
    cancelCardTypeDialog(){
      this.dialogValue = false;
    },
    cancelCardTypeOtherDialog(){
      this.dialogOtherValue = false;
    },
    handleCardTypeSubmit(value){
      this.bookingForm.cardTypeSelectDisabled = true;
      this.bookingForm.cardTypeButtonDisabled = true;
      this.bookingForm.cardTypeNumber = value.certificateNumber;
      this.bookingForm.cardType = value.certificateType;
      this.bookingForm.passportNumber = value.certificateType;
      this.bookingForm.idCardNumber = value.certificateNumber;
      if(value.certificateType=="NI" || value.certificateType=="GATJZZ"){
        return;
      }
      this.bookingForm.birthday = value.birthDate;
      this.bookingForm.sex = value.gender;
      this.bookingForm.visaCountry = value.issuingCountryCode;
    },
    handleCardTypeOtherSubmit(value){
      this.bookingForm.bookingFormOther.cardTypeSelectDisabled = true;
      this.bookingForm.bookingFormOther.cardTypeButtonDisabled = true;
      this.bookingForm.bookingFormOther.cardTypeNumber = value.certificateNumber;
      this.bookingForm.bookingFormOther.cardType = value.certificateType;
      this.bookingForm.bookingFormOther.passportNumber = value.certificateType;
      this.bookingForm.bookingFormOther.idCardNumber = value.certificateNumber;
      if(value.certificateType=="NI" || value.certificateType=="GATJZZ"){
        return;
      }
      this.bookingForm.bookingFormOther.birthday = value.birthDate;
      this.bookingForm.bookingFormOther.sex = value.gender;
      this.bookingForm.bookingFormOther.visaCountry = value.issuingCountryCode;
    }
  },
  directives:{
    'el-select-loadmore':(el, binding) => {
      // 获取element-ui定义好的scroll盒子
      const SELECTWRAP_DOM = el.querySelector(".el-select-dropdown .el-select-dropdown__wrap");
      if(SELECTWRAP_DOM){
        SELECTWRAP_DOM.addEventListener("scroll", function () {
          /**
           * scrollHeight 获取元素内容高度(只读)
           * scrollTop 获取或者设置元素的偏移值,
           *  常用于:计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
           * clientHeight 读取元素的可见高度(只读)
           * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
           * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
           */
          const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
          if (condition) 
          {
            binding.value();
          }
        });
      }
    }
  },
};
</script>
<style lang="stylus">
/* 手机、平板屏幕 */
@media screen and (max-width: 960px) {
  ::v-deep .van-tab__text {
    font-size: 1.6rem;
  }
  .mobileSearchStyle {
    margin: 1rem 1rem;
    border-radius: 5rem;
    align-items: center;
    .van-search__content {
      height: 4rem;
      padding-left: 1rem;
      border-radius: 5rem;
      display: flex;
      align-items: center;
      .van-search__label {
        font-size: 1.4rem;
        line-height: 4rem;
      }
      .van-field__body,
      .van-field__control {
        height: 4rem;
        line-height: 4rem;
      }
    }
    .van-search__action {
      display: flex;
      align-items: center;
      height: 4rem;
      line-height: 4rem;
      margin-right: 1rem;
      font-size: 1.4rem;
    }
  }
  ::v-deep .van-radio__icon .van-icon {
    border: 1px solid #c8c9cc;
  }
  .guestAddField {
    padding: 0.5rem 1.5rem;
    ::v-deep .van-cell__title {
      flex: 1;
      span {
        font-size: 1.4rem;
        padding-left: 1.5rem;
      }
    }
    ::v-deep .van-cell__value{
      font-size: 1.4rem;
      flex: 5;
    }
  }
  .addGuestMobile {
    display: block;
    width: 30rem;
    font-size: 1.6rem;
    height: 5rem;
    margin: 1rem auto;
  }
  .traval-pop-chose {
    font-size: 1.4rem;
    padding: 2rem;
  }
  .traval-pop-cell-content {
    display: flex;
    align-items: center;
    width: 100%;
  }
  .traval-pop-cell-title {
    flex: 1;
    padding-right: 1rem;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .traval-pop-cell-content .van-radio {
    display: flex;
    align-items: center;
    flex: 0 0 auto;
    margin-left: auto;
  }
  .traval-pop-cell-content .van-radio__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  .traval-pop-cell-content .van-radio__icon .van-icon {
    width: 2rem;
    height: 2rem;
    line-height: 2rem;
    border: 1px solid #c8c9cc;
    border-radius: 50%;
    box-sizing: border-box;
  }
  .traval-pop-title {
    font-size: 1.7rem;
    margin: 1rem;
    text-align: center;
  }
  ::v-deep .el-range-input,
  ::v-deep .el-date-editor .el-range-separator,
  .el-select-dropdown__item {
    font-size: 1.4rem;
  }
  ::v-deep .el-breadcrumb {
    display: none;
  }
  // .hotel_container_panel {
  //   padding: 0px;
  // }

  ::v-deep .el-input__inner {
    height: 2.7rem;
    line-height: 2.7rem;
    font-size: 1.4rem;
  }

  ::v-deep .el-input__icon {
    line-height: 25px;
  }

  .panel_bg {
    background-color: $btn-font-color;
  }

  .confirmation_panel {
    display: unset;

    .info_detal_l {
      flex: 1;
      overflow: hidden;
      padding-right: 0rem;
      margin-bottom: 1.3rem;
    }
  }
  .special_checkin {
    padding: 1.3rem;
  }

  .special_prompt {
    display: flex;
    border-bottom: 0.2rem solid $btn-bg-color;
    margin-bottom: 1.3rem;
    padding-bottom: 0.8rem;
    font-weight: 600;
    span {
      font-size: 1.4rem;
      line-height: 2rem;
      padding-right: 1.3rem;
      width: 47.8rem;

      span {
        color: $text-fill-color;
      }
    }

    p {
      font-size: 1.2rem;
      color: $text-fill-color;
      display: inline-block;
    }
  }

  .special_alert {
    font-size: 1.2rem;
    color: $btn-bg-color;
    margin-top: 1.3rem;
  }

  .booking_price {
    border-bottom: 0.2rem dashed $bg-color;
  }

  .avg-price {
    font-size: 1.8rem;
    line-height: 2.5rem;
    display: flex;
    justify-content: space-between;
    padding-bottom: 1.3rem;
  }
  .booking_policies {
    height: 2rem;
    line-height: 2rem;
    font-size: 1.4rem;
    padding: 0.5rem 1.3rem;
    background-color: $bg-color;
    margin-top: 1.2rem;
  }
  .chk_note {
    margin: 3rem 0;
  }
  .star_icon {
    width: 1.4rem;
    height: 1.4rem;
  }
  .taxState {
    margin-top: 1rem;
  }

  .title-divider {
    margin-bottom: 1rem;
    margin-top: -1rem;
    height: 2px;
    background-color: $btn-bg-color;
  }
  ::v-deep .el-checkbox__input {
    vertical-align: top;
    padding-top: 0.4rem;
  }

  ::v-deep .el-checkbox__label {
    white-space: pre-wrap;
    font-size: 1.4rem;
    color: #606266!important;
  }

  ::v-deep .el-select {
    width: 100%;
  }

  .checkin_prompt {
    display: flex;
    border-bottom: 0.2rem solid $btn-bg-color;
    margin: 1.3rem 0;
    padding-bottom: 0.8rem;
    font-weight: 600;
    span {
      font-size: 1.4rem;
      line-height: 2rem;
      padding-right: 1.3rem;
      width: 15.7rem;
    }

    p {
      font-size: 1.2rem;
      color: $btn-bg-color;
      display: inline;
    }
  }

  .room-info {
    .title {
      font-size: 1.2rem;
      line-height: 2rem;
    }
  }

  .panel_dividing_line {
    border-bottom: 0.2rem dashed #e7e9ea;
    margin-top: 1.3rem;
  }

  .special_alert {
    font-size: 1.2rem;
    color: $btn-bg-color;
    margin-top: 1.3rem;
  }

  .dialog-one ::v-deep .el-dialog {
    width: 90%;
  }

  ::v-deep .dialog-one .el-dialog__header, ::v-deep .dialog-one .el-tabs__active-bar {
    display: none;
  }

  ::v-deep .dialog-one .el-dialog__body {
    padding: 0px;
  }

  ::v-deep .el-tabs__item {
    padding: 0px 10px;
  }

  ::v-deep .el-tabs__item.is-active {
    background: $tab-color-active;
    color: #000;
    margin-bottom: 2px;
    padding-right: 10px;
  }

  ::v-deep .el-tabs__item.is-top:nth-child(2) {
    padding-left: 10px;
  }

  ::v-deep .el-tabs__item.is-top:last-child {
    padding-right: 10px;
  }

  ::v-deep .el-tabs__item {
    text-align: center;
    font-size: 14px;
    /*font-weight: 600;*/
  }

  ::v-deep .el-tabs__nav-wrap {
    position: unset;
    pointer-events: auto;
  }

  ::v-deep .el-tabs__nav-wrap::after {
    background-color: $btn-bg-color;
    width: 100%;
  }

  .add-guest-div {
    position: absolute;
    top: 15px;
    right: 40px;
    z-index: 1000;
  }

  .add-guest-btn {
    padding: 8px 13px;
    background-color: $btn-bg-color;
    color: $btn-font-color;
    pointer-events: auto;
  }

  .search-input {
    margin-left: 10%;
  }

  .search-btn {
    margin: 2% 5%;

    button {
      padding: 7px 20px;
      border: 1px solid $btn-bg-color;
      color: $btn-bg-color;
    }
  }

  .user-search-row {
    display: flex;
    flex-wrap: nowrap;
    align-items: flex-end;

    .search-input,
    .search-btn {
      margin: 0;
    }

    .search-btn {
      display: flex;
      align-items: flex-end;
    }
  }

  ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: $btn-bg-color;
  }

  ::v-deep .el-tabs__header {
    pointer-events: none;
  }

  .dialog-footer {
    text-align: center;
  }

  .dialog-footer button {
    padding: 2% 10%;
    border: 1px solid $btn-bg-color;
  }

  .dialog-footer .search-btn {
    background-color: $btn-bg-color;
  }

  .dialog-two {
    font-weight: 600;
    ::v-deep .el-dialog__body {
      padding: 3rem 0px 0px 0px;
    }

    .title-divider {
      height: 2px;
      background-color: $btn-bg-color;
    }
  }

  .select-btn {
    color: $btn-bg-color;
    cursor: pointer;
  }

  .dialog-form-row {
    margin: 2rem auto;
    ::v-deep .el-input__inner {
      width: 25rem;
    }
  }

  .form-label-field {
    ::v-deep .el-form-item__label {
      font-size: 1.4rem;
      height: 2rem;
      line-height: 2rem;
      margin-top: 1rem;
      color: $text-fill-color;
    }
  }
  .dialog-traveler ::v-deep .el-dialog__header{
    border-bottom: 2px solid $btn-bg-color;
    padding: 1rem;
  }

  ::v-deep .el-table__fixed-right::before, ::v-deep .el-table__fixed::before{
    z-index: inherit;
  }

  .d_confirm {
    ::v-deep .el-dialog__body, ::v-deep .el-dialog__footer {
      padding: 1rem 2rem;
    }

    ::v-deep .el-dialog__header {
      border-top: 4px solid $btn-bg-color;
    }
  }

  .dialog-span-fixed {
    display: flex;

    .dialog-span-content {
      margin-left: 1rem;
    }
  }
  .dialog_btn_y {
    background-color: $btn-bg-color;
    color: $btn-font-color;
    border: 0px;
    text-transform: uppercase;
    cursor: pointer;
    border-radius: 0.3rem;
    font-family: Source-Sans-Bold;
  }
  .four_btn {
    width: 13rem;
    height: 4rem;
  }
  .loyaltyCard-btn
  {
    button {
      margin-top:0.5rem;
      padding: 5px;
      border: 1px solid $btn-bg-color;
      color: $btn-bg-color;
    }
  }
  .col_loyaltyCard{
    text-align: right;
  }
  .message-prompt{
    margin: 5px auto;
    font-size: 12px;
    font-weight: 500;
    text-align: center;
    background-color: initial;
    border-top: 0;
  }
}
/* 电脑屏幕 */
@media screen and (min-width: 961px) {
  ::v-deep .el-input__inner {
    height: 2.7rem;
    line-height: 2.7rem;
  }

  ::v-deep .el-input__icon {
    line-height: 25px;
  }

  .panel_bg {
    background-color: $btn-font-color;
  }

  .confirmation_panel {
    display: flex;

    .info_detal_l {
      flex: 1;
      overflow: hidden;
      padding-right: 1.3rem;

      .base:not(:last-child) {
        margin-bottom: 1.3rem;
      }
    }
  }
  .special_checkin {
    padding: 1.3rem;
  }

  .special_prompt {
    display: flex;
    border-bottom: 0.2rem solid $btn-bg-color;
    margin-bottom: 1.3rem;
    padding-bottom: 0.8rem;
    font-weight: 600;
    span {
      font-size: 14px;
      line-height: 20px;
      padding-right: 1.3rem;
      width: 47.8rem;

      span {
        color: $text-fill-color;
      }
    }

    p {
      font-size: 12px;
      color: $text-fill-color;
      display: inline-block;
    }
  }

  .special_alert {
    font-size: 1.2rem;
    color: $btn-bg-color;
    margin-top: 1.3rem;
  }
  .avg-price {
    font-size: 1.8rem;
    line-height: 2.5rem;
    display: flex;
    justify-content: space-between;
    padding-bottom: 1.3rem;
  }

  .booking_policies {
    height: 2rem;
    line-height: 2rem;
    font-size: 1.4rem;
    padding: 0.5rem 1.3rem;
    background-color: $bg-color;
    margin-top: 1.2rem;
  }
  .chk_note {
    margin: 3rem 0;
  }

  .star_icon {
    width: 1.4rem;
    height: 1.4rem;
  }
  .taxState {
    margin-top: 1rem;
  }

  .title-divider {
    margin-bottom: 1rem;
    margin-top: -1rem;
    height: 2px;
    background-color: $btn-bg-color;
  }
  ::v-deep .el-checkbox__input {
    vertical-align: top;
    padding-top: 0.4rem;
  }

  ::v-deep .el-checkbox__label {
    white-space: pre-wrap;
  }

  ::v-deep .el-select {
    width: 100%;
  }

  .checkin_prompt {
    display: flex;
    border-bottom: 0.2rem solid $btn-bg-color;
    margin: 1.3rem 0;
    padding-bottom: 0.8rem;
    font-weight: 600;
    span {
      font-size: 1.4rem;
      line-height: 2rem;
      padding-right: 1.3rem;
      width: 15.7rem;
    }

    p {
      font-size: 1.2rem;
      color: $btn-bg-color;
      display: inline;
    }
  }

  .room-info {
    .title {
      font-size: 1.2rem;
      line-height: 2rem;
    }
  }

  .panel_dividing_line {
    border-bottom: 0.2rem dashed #e7e9ea;
    margin-top: 1.3rem;
  }

  .special_alert {
    font-size: 1.2rem;
    color: $btn-bg-color;
    margin-top: 1.3rem;
  }

  .dialog-one ::v-deep .el-dialog {
    width: 90rem;
  }

  ::v-deep .dialog-one .el-dialog__header, ::v-deep .dialog-one .el-tabs__active-bar {
    display: none;
  }

  ::v-deep .dialog-one .el-dialog__body {
    padding: 0px;
  }

  ::v-deep .el-tabs__item {
    padding: 0px 10px;
  }

  ::v-deep .el-tabs__item.is-active {
    background: $tab-color-active;
    color: #000;
    margin-bottom: 2px;
    padding-right: 10px;
  }

  ::v-deep .el-tabs__item.is-top:nth-child(2) {
    padding-left: 10px;
  }

  ::v-deep .el-tabs__item.is-top:last-child {
    padding-right: 10px;
  }

  ::v-deep .el-tabs__item {
    text-align: center;
    font-size: 14px;
    /*font-weight: 600;*/
  }

  ::v-deep .el-tabs__nav-wrap {
    position: unset;
    pointer-events: auto;
  }

  ::v-deep .el-tabs__nav-wrap::after {
    background-color: $btn-bg-color;
    width: 100%;
  }

  .add-guest-div {
    position: absolute;
    top: 15px;
    right: 40px;
    z-index: 1000;
  }

  .add-guest-btn {
    padding: 8px 13px;
    background-color: $btn-bg-color;
    color: $btn-font-color;
    pointer-events: auto;
  }

  .search-input {
    margin-left: 10%;
  }

  .search-btn {
    margin: 2% 5%;

    button {
      padding: 7px 20px;
      border: 1px solid $btn-bg-color;
      color: $btn-bg-color;
    }
  }

  .user-search-row {
    display: flex;
    flex-wrap: nowrap;
    align-items: flex-end;

    .search-input,
    .search-btn {
      margin: 0;
    }

    .search-btn {
      display: flex;
      align-items: flex-end;
    }
  }

  ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: $btn-bg-color;
  }

  ::v-deep .el-tabs__header {
    pointer-events: none;
  }

  .dialog-footer {
    text-align: center;
  }

  .dialog-footer button {
    padding: 2% 10%;
    border: 1px solid $btn-bg-color;
  }

  .dialog-footer .search-btn {
    background-color: $btn-bg-color;
  }

  .dialog-two {
    font-weight: 600;
    ::v-deep .el-dialog__body {
      padding: 3rem 0px 0px 0px;
    }

    .title-divider {
      height: 2px;
      background-color: $btn-bg-color;
    }
  }

  .select-btn {
    color: $btn-bg-color;
    cursor: pointer;
  }

  .dialog-form-row {
    margin: 2rem auto;
    ::v-deep .el-input__inner {
      width: 25rem;
    }
  }

  .form-label-field {
    ::v-deep .el-form-item__label {
      font-size: 1.4rem;
      height: 2rem;
      line-height: 2rem;
      margin-top: 1rem;
      color: $text-fill-color;
    }
  }
  .dialog-traveler ::v-deep .el-dialog__header{
    border-bottom: 2px solid $btn-bg-color;
    padding: 1rem;
  }

  ::v-deep .el-table__fixed-right::before, ::v-deep .el-table__fixed::before{
    z-index: inherit;
  }

  .d_confirm {
    ::v-deep .el-dialog__body, ::v-deep .el-dialog__footer {
      padding: 1rem 2rem;
    }

    ::v-deep .el-dialog__header {
      border-top: 4px solid $btn-bg-color;
    }
  }

  .dialog-span-fixed {
    display: flex;

    .dialog-span-content {
      margin-left: 1rem;
    }
  }
  .dialog_btn_y {
    background-color: $btn-bg-color;
    color: $btn-font-color;
    border: 0px;
    text-transform: uppercase;
    cursor: pointer;
    border-radius: 0.3rem;
    font-family: Source-Sans-Bold;
  }
  .four_btn {
    width: 13rem;
    height: 4rem;
  }
  .loyaltyCard-btn
  {
    button {
      margin-top:4.3rem;
      padding: 7px;
      border: 1px solid $btn-bg-color;
      color: $btn-bg-color;
    }
  }
  .col_loyaltyCard{
    padding-bottom:15px;
  }
}
.star-rate {
  margin-top: 1rem;
}
::v-deep .el-rate__icon {
  font-size: 2rem;
  margin-right: 0;
}
.colorRed{
  color:red;
  font-size:1.2rem;
  margin-top:0.5rem;
}
.miNoteFont{
  color:rgb(111, 120, 126);
  font-size:1.4rem;
}
.miNoteFontT{
  cursor:pointer;
  text-decoration:underline;
}
.miNoteFontF{
  cursor:default;
  text-decoration:none;
}
.editCardTypeButtonStyle{
  white-space: nowrap;
  height: 25px;
  line-height: 25px;
  font-size: 14px;
  background-color: rgb(252, 102, 64);
  color: #fff;
  border: 0px;
  border-radius: 0.3rem;
  width: 10rem;
  padding:0;
}
::v-deep .el-select__wrapper{
  min-height: 24px;
}
</style>
